import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children", "size"],
  _excluded2 = ["children", "size"],
  _excluded3 = ["children", "size"],
  _excluded4 = ["children", "size"],
  _excluded5 = ["children", "size"],
  _excluded6 = ["children", "size"],
  _excluded7 = ["children", "size"],
  _excluded8 = ["children", "size"],
  _excluded9 = ["children", "size"],
  _excluded10 = ["children", "size"],
  _excluded11 = ["children", "size"],
  _excluded12 = ["children", "size"],
  _excluded13 = ["children", "size"],
  _excluded14 = ["children", "size"],
  _excluded15 = ["children", "size"],
  _excluded16 = ["children", "size"],
  _excluded17 = ["children", "size"],
  _excluded18 = ["children", "size"],
  _excluded19 = ["children", "size"],
  _excluded20 = ["children", "size"],
  _excluded21 = ["children", "size"],
  _excluded22 = ["children", "size"],
  _excluded23 = ["children", "size"],
  _excluded24 = ["children", "size"],
  _excluded25 = ["children", "size"],
  _excluded26 = ["children", "size"],
  _excluded27 = ["children", "size"],
  _excluded28 = ["children", "size"],
  _excluded29 = ["children", "size"],
  _excluded30 = ["children", "size"],
  _excluded31 = ["children", "size"],
  _excluded32 = ["children", "size"],
  _excluded33 = ["children", "size"],
  _excluded34 = ["children", "size"],
  _excluded35 = ["children", "size"],
  _excluded36 = ["children", "size"],
  _excluded37 = ["children", "size"],
  _excluded38 = ["children", "size"],
  _excluded39 = ["children", "size"],
  _excluded40 = ["children", "size"],
  _excluded41 = ["children", "size"],
  _excluded42 = ["children", "size"],
  _excluded43 = ["children", "size"],
  _excluded44 = ["children", "size"],
  _excluded45 = ["children", "size"],
  _excluded46 = ["children", "size"],
  _excluded47 = ["children", "size"],
  _excluded48 = ["children", "size"],
  _excluded49 = ["children", "size"],
  _excluded50 = ["children", "size"],
  _excluded51 = ["children", "size"],
  _excluded52 = ["children", "size"],
  _excluded53 = ["children", "size"],
  _excluded54 = ["children", "size"],
  _excluded55 = ["children", "size"],
  _excluded56 = ["children", "size"],
  _excluded57 = ["children", "size"],
  _excluded58 = ["children", "size"],
  _excluded59 = ["children", "size"],
  _excluded60 = ["children", "size"],
  _excluded61 = ["children", "size"],
  _excluded62 = ["children", "size"],
  _excluded63 = ["children", "size"],
  _excluded64 = ["children", "size"],
  _excluded65 = ["children", "size"],
  _excluded66 = ["children", "size"],
  _excluded67 = ["children", "size"],
  _excluded68 = ["children", "size"],
  _excluded69 = ["children", "size"],
  _excluded70 = ["children", "size"],
  _excluded71 = ["children", "size"],
  _excluded72 = ["children", "size"],
  _excluded73 = ["children", "size"],
  _excluded74 = ["children", "size"],
  _excluded75 = ["children", "size"],
  _excluded76 = ["children", "size"],
  _excluded77 = ["children", "size"],
  _excluded78 = ["children", "size"],
  _excluded79 = ["children", "size"],
  _excluded80 = ["children", "size"],
  _excluded81 = ["children", "size"],
  _excluded82 = ["children", "size"],
  _excluded83 = ["children", "size"],
  _excluded84 = ["children", "size"],
  _excluded85 = ["children", "size"],
  _excluded86 = ["children", "size"],
  _excluded87 = ["children", "size"],
  _excluded88 = ["children", "size"],
  _excluded89 = ["children", "size"],
  _excluded90 = ["children", "size"],
  _excluded91 = ["children", "size"],
  _excluded92 = ["children", "size"],
  _excluded93 = ["children", "size"],
  _excluded94 = ["children", "size"],
  _excluded95 = ["children", "size"],
  _excluded96 = ["children", "size"],
  _excluded97 = ["children", "size"],
  _excluded98 = ["children", "size"],
  _excluded99 = ["children", "size"],
  _excluded100 = ["children", "size"],
  _excluded101 = ["children", "size"],
  _excluded102 = ["children", "size"],
  _excluded103 = ["children", "size"],
  _excluded104 = ["children", "size"],
  _excluded105 = ["children", "size"],
  _excluded106 = ["children", "size"],
  _excluded107 = ["children", "size"],
  _excluded108 = ["children", "size"],
  _excluded109 = ["children", "size"],
  _excluded110 = ["children", "size"],
  _excluded111 = ["children", "size"],
  _excluded112 = ["children", "size"],
  _excluded113 = ["children", "size"],
  _excluded114 = ["children", "size"],
  _excluded115 = ["children", "size"],
  _excluded116 = ["children", "size"],
  _excluded117 = ["children", "size"],
  _excluded118 = ["children", "size"],
  _excluded119 = ["children", "size"],
  _excluded120 = ["children", "size"],
  _excluded121 = ["children", "size"],
  _excluded122 = ["children", "size"],
  _excluded123 = ["children", "size"],
  _excluded124 = ["children", "size"],
  _excluded125 = ["children", "size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Code generated by @carbon/icon-build-helpers. DO NOT EDIT.
 */
import React from 'react';
import Icon from '../Icon.js';
import { i as iconPropTypes } from '../iconPropTypes-4cbeb95d.js';
import '@carbon/icon-helpers';
var _path, _path2, _path3, _circle, _path4, _path5, _path6, _path7, _circle2, _circle3, _path8, _path9, _circle4, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _circle12, _circle13, _circle14, _circle15, _circle16, _path32, _path33, _path34, _path35, _path36, _path37, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _path38, _path39, _circle23, _circle24, _circle25, _circle26, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _circle27, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _circle28, _circle29, _circle30, _path98, _path99, _path100, _path101, _path102, _path103, _circle31, _circle32, _circle33, _path104, _path105, _path106, _path107, _circle34, _circle35, _circle36, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _circle37, _path115, _path116, _path117, _path118, _circle38, _path119, _circle39, _circle40, _circle41, _path120, _circle42, _path121, _path122, _path123, _circle43, _path124, _path125, _path126, _circle44, _circle45, _circle46, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _circle47, _path134, _circle48, _path135, _path136, _path137, _switch, _switch2, _path138, _path139, _switch3, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _circle49, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _circle50, _path169, _circle51, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177;
var didWarnAboutDeprecation = {};
var ContainerImagePushPull = /*#__PURE__*/React.forwardRef(function ContainerImagePushPull(_ref, ref) {
  var children = _ref.children,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 16 : _ref$size,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M30 23h-10c-1.1028 0-2-.8972-2-2v-10c0-1.1028.8972-2 2-2h10c1.1028 0 2 .8972 2 2v10c0 1.1028-.8972 2-2 2zm-10-12v10h10v-10h-10zM9 5L14 10 9 15 7.581 13.591 10.153 11 0 11 0 9 10.206 9 7.581 6.409 9 5zM5 27L0 22 5 17 6.419 18.409 3.847 21 14 21 14 23 3.794 23 6.419 25.591 5 27z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var ContainerRegistry = /*#__PURE__*/React.forwardRef(function ContainerRegistry(_ref2, ref) {
  var children = _ref2.children,
    _ref2$size = _ref2.size,
    size = _ref2$size === void 0 ? 16 : _ref2$size,
    rest = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17,13V6H8V22H24V13ZM10,8h5v5H10Zm0,7h5v5H10Zm12,5H17V15h5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 11H19V2h9zM21 9h5V4H21zM28 20H26v2h2v6H4V22H6V20H4a2.0024 2.0024 0 00-2 2v6a2.0024 2.0024 0 002 2H28a2.0024 2.0024 0 002-2V22A2.0024 2.0024 0 0028 20z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "25",
    r: "1"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var ContainerServices = /*#__PURE__*/React.forwardRef(function ContainerServices(_ref3, ref) {
  var children = _ref3.children,
    _ref3$size = _ref3.size,
    size = _ref3$size === void 0 ? 16 : _ref3$size,
    rest = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27,22V17a2.0023,2.0023,0,0,0-2-2H17V10h3a2.0023,2.0023,0,0,0,2-2V4a2.0023,2.0023,0,0,0-2-2H12a2.0023,2.0023,0,0,0-2,2V8a2.0023,2.0023,0,0,0,2,2h3v5H7a2.0023,2.0023,0,0,0-2,2v5H2v8h8V22H7V17h8v5H12v8h8V22H17V17h8v5H22v8h8V22ZM12,4h8V8H12ZM8,28H4V24H8Zm10,0H14V24h4Zm10,0H24V24h4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var ContainerSoftware = /*#__PURE__*/React.forwardRef(function ContainerSoftware(_ref4, ref) {
  var children = _ref4.children,
    _ref4$size = _ref4.size,
    size = _ref4$size === void 0 ? 16 : _ref4$size,
    rest = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28,12H20V4h8Zm-6-2h4V6H22Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17,15V9H9V23H23V15Zm-6-4h4v4H11Zm4,10H11V17h4Zm6,0H17V17h4Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26,28H6a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,6,4H16V6H6V26H26V16h2V26A2.0023,2.0023,0,0,1,26,28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var ContentDeliveryNetwork = /*#__PURE__*/React.forwardRef(function ContentDeliveryNetwork(_ref5, ref) {
  var children = _ref5.children,
    _ref5$size = _ref5.size,
    size = _ref5$size === void 0 ? 16 : _ref5$size,
    rest = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "21",
    r: "2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "7",
    r: "2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27,31a4,4,0,1,1,4-4A4.0118,4.0118,0,0,1,27,31Zm0-6a2,2,0,1,0,2,2A2.0059,2.0059,0,0,0,27,25Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30,16A14.0412,14.0412,0,0,0,16,2,13.0426,13.0426,0,0,0,9.2,3.8l1.1,1.7a24.4254,24.4254,0,0,1,2.4-1A25.1349,25.1349,0,0,0,10,15H4a11.1489,11.1489,0,0,1,1.4-4.7L3.9,9A13.8418,13.8418,0,0,0,2,16,13.9983,13.9983,0,0,0,16,30a13.3656,13.3656,0,0,0,5.2-1l-.6-1.9a11.4416,11.4416,0,0,1-5.2.9h0A21.0713,21.0713,0,0,1,12,17H29.9A3.4019,3.4019,0,0,0,30,16ZM12.8,27.6h0a13.02,13.02,0,0,1-5.3-3.1A12.5053,12.5053,0,0,1,4,17h6A25.0022,25.0022,0,0,0,12.8,27.6ZM12,15A21.4461,21.4461,0,0,1,15.3,4h1.4A21.4461,21.4461,0,0,1,20,15Zm10,0A23.2777,23.2777,0,0,0,19.2,4.4,12.0919,12.0919,0,0,1,27.9,15Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var ContentView = /*#__PURE__*/React.forwardRef(function ContentView(_ref6, ref) {
  var children = _ref6.children,
    _ref6$size = _ref6.size,
    size = _ref6$size === void 0 ? 16 : _ref6$size,
    rest = _objectWithoutProperties(_ref6, _excluded6);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "19",
    r: "2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7769,18.4785A8.64,8.64,0,0,0,16,13a8.64,8.64,0,0,0-7.7769,5.4785L8,19l.2231.5215A8.64,8.64,0,0,0,16,25a8.64,8.64,0,0,0,7.7769-5.4785L24,19ZM16,23a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,23Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M27,3H5A2,2,0,0,0,3,5V27a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2V5A2,2,0,0,0,27,3ZM5,5H27V9H5ZM5,27V11H27V27Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Continue = /*#__PURE__*/React.forwardRef(function Continue(_ref7, ref) {
  var children = _ref7.children,
    _ref7$size = _ref7.size,
    size = _ref7$size === void 0 ? 16 : _ref7$size,
    rest = _objectWithoutProperties(_ref7, _excluded7);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M10 28a1 1 0 01-1-1V5a1 1 0 011.501-.8652l19 11a1 1 0 010 1.73l-19 11A.9975.9975 0 0110 28zM11 6.7344V25.2656L27 16zM4 4H6V28H4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var ContinueFilled = /*#__PURE__*/React.forwardRef(function ContinueFilled(_ref8, ref) {
  var children = _ref8.children,
    _ref8$size = _ref8.size,
    size = _ref8$size === void 0 ? 16 : _ref8$size,
    rest = _objectWithoutProperties(_ref8, _excluded8);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M10 28a1 1 0 01-1-1V5a1 1 0 011.501-.8652l19 11a1 1 0 010 1.73l-19 11A.9975.9975 0 0110 28zM4 4H6V28H4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var ContinuousDeployment = /*#__PURE__*/React.forwardRef(function ContinuousDeployment(_ref9, ref) {
  var children = _ref9.children,
    _ref9$size = _ref9.size,
    size = _ref9$size === void 0 ? 16 : _ref9$size,
    rest = _objectWithoutProperties(_ref9, _excluded9);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M24,2l-6,6l1.4,1.4L23,5.8V19c0,5-4,9-9,9c-1.6,0-3.1-0.4-4.3-1.1C10.1,27,10.5,27,11,27c4.4,0,8-3.6,8-8s-3.6-8-8-8 s-8,3.6-8,8c0,6.1,4.9,11,11,11s11-4.9,11-11V5.8l3.6,3.6L30,8L24,2z M5,19.6c0-0.2,0-0.4,0-0.6c0-3.3,2.7-6,6-6s6,2.7,6,6 s-2.7,6-6,6C7.9,25,5.3,22.6,5,19.6z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var ContinuousIntegration = /*#__PURE__*/React.forwardRef(function ContinuousIntegration(_ref10, ref) {
  var children = _ref10.children,
    _ref10$size = _ref10.size,
    size = _ref10$size === void 0 ? 16 : _ref10$size,
    rest = _objectWithoutProperties(_ref10, _excluded10);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9,15.5l-5.7-10C25.9,5.2,25.6,5,25.3,5H6.7C6.4,5,6.1,5.2,5.9,5.5l-5.7,10C0,15.7,0,15.8,0,16s0,0.3,0.1,0.5l5.7,10 C6.1,26.8,6.4,27,6.7,27h18.5c0.4,0,0.7-0.2,0.9-0.5l5.7-10C32,16.3,32,16.2,32,16S32,15.7,31.9,15.5z M17.8,15h-8l4-7L17.8,15z M15.5,7h8l-4,7L15.5,7z M17.8,17l-4,7l-4-7H17.8z M19.5,18l4,7h-8L19.5,18z M21.2,17h8l-4,7L21.2,17z M21.2,15l4-7l4,7H21.2z M7.3,7H12l-4.6,8H2.7L7.3,7z M7.3,25l-4.6-8h4.7l4.6,8H7.3z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var WatsonHealthContourDraw = /*#__PURE__*/React.forwardRef(function WatsonHealthContourDraw(_ref11, ref) {
  var children = _ref11.children,
    _ref11$size = _ref11.size,
    size = _ref11$size === void 0 ? 16 : _ref11$size,
    rest = _objectWithoutProperties(_ref11, _excluded11);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7 4.7a14.7029 14.7029 0 00-3 3.1L6.3 9A13.2634 13.2634 0 018.9 6.3zM4.6 12.3l-1.9-.6A12.5111 12.5111 0 002 16H4A11.4756 11.4756 0 014.6 12.3zM11.7 2.7l.6 1.9A11.4756 11.4756 0 0116 4V2A12.5111 12.5111 0 0011.7 2.7zM24.2 27.3a15.18 15.18 0 003.1-3.1L25.7 23A11.526 11.526 0 0123 25.7zM27.4 19.7l1.9.6A15.4747 15.4747 0 0030 16H28A11.4756 11.4756 0 0127.4 19.7zM29.2 11.6a14.4029 14.4029 0 00-2-3.9L25.6 8.9a12.8867 12.8867 0 011.7 3.3zM24.1 4.6a14.4029 14.4029 0 00-3.9-2l-.6 1.9a12.8867 12.8867 0 013.3 1.7zM20.3 29.3l-.6-1.9A11.4756 11.4756 0 0116 28v2A21.4206 21.4206 0 0020.3 29.3zM15.4023 24.248a11.9488 11.9488 0 00-1.7182-3.3354L15.2974 19.73a13.9486 13.9486 0 012.0044 3.893zM11.02 18.2668a11.9215 11.9215 0 00-3.3467-1.6943l.6114-1.9043a13.9242 13.9242 0 013.9072 1.978z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var WatsonHealthContourEdit = /*#__PURE__*/React.forwardRef(function WatsonHealthContourEdit(_ref12, ref) {
  var children = _ref12.children,
    _ref12$size = _ref12.size,
    size = _ref12$size === void 0 ? 16 : _ref12$size,
    rest = _objectWithoutProperties(_ref12, _excluded12);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M16 30V28A12.0021 12.0021 0 0019.6924 4.5786l.6152-1.9033A14.0022 14.0022 0 0116 30zM7.7 4.7a14.7029 14.7029 0 00-3 3.1L6.3 9A13.2634 13.2634 0 018.9 6.3zM4.6 12.3l-1.9-.6A12.5111 12.5111 0 002 16H4A11.4756 11.4756 0 014.6 12.3zM11.7 2.7l.6 1.9A11.4756 11.4756 0 0116 4V2A12.5111 12.5111 0 0011.7 2.7z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4023 24.248a11.9488 11.9488 0 00-1.7182-3.3354L15.2974 19.73a13.9486 13.9486 0 012.0044 3.893zM11.02 18.2668a11.9215 11.9215 0 00-3.3467-1.6943l.6114-1.9043a13.9242 13.9242 0 013.9072 1.978z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var WatsonHealthContourFinding = /*#__PURE__*/React.forwardRef(function WatsonHealthContourFinding(_ref13, ref) {
  var children = _ref13.children,
    _ref13$size = _ref13.size,
    size = _ref13$size === void 0 ? 16 : _ref13$size,
    rest = _objectWithoutProperties(_ref13, _excluded13);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7 4.7a14.7029 14.7029 0 00-3 3.1L6.3 9A13.2634 13.2634 0 018.9 6.3zM4.6 12.3l-1.9-.6A12.5111 12.5111 0 002 16H4A11.4756 11.4756 0 014.6 12.3zM2.7 20.4a14.4029 14.4029 0 002 3.9l1.6-1.2a12.8867 12.8867 0 01-1.7-3.3zM7.8 27.3a14.4029 14.4029 0 003.9 2l.6-1.9A12.8867 12.8867 0 019 25.7zM11.7 2.7l.6 1.9A11.4756 11.4756 0 0116 4V2A12.5111 12.5111 0 0011.7 2.7zM24.2 27.3a15.18 15.18 0 003.1-3.1L25.7 23A11.526 11.526 0 0123 25.7zM27.4 19.7l1.9.6A15.4747 15.4747 0 0030 16H28A11.4756 11.4756 0 0127.4 19.7zM29.2 11.6a14.4029 14.4029 0 00-2-3.9L25.6 8.9a12.8867 12.8867 0 011.7 3.3zM24.1 4.6a14.4029 14.4029 0 00-3.9-2l-.6 1.9a12.8867 12.8867 0 013.3 1.7zM20.3 29.3l-.6-1.9A11.4756 11.4756 0 0116 28v2A21.4206 21.4206 0 0020.3 29.3zM16 26A10 10 0 1126 16 10.0115 10.0115 0 0116 26zM16 8a8 8 0 108 8A8.0092 8.0092 0 0016 8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Contrast = /*#__PURE__*/React.forwardRef(function Contrast(_ref14, ref) {
  var children = _ref14.children,
    _ref14$size = _ref14.size,
    size = _ref14$size === void 0 ? 16 : _ref14$size,
    rest = _objectWithoutProperties(_ref14, _excluded14);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M29.37,11.84a13.6,13.6,0,0,0-1.06-2.51A14.17,14.17,0,0,0,25.9,6.1a14,14,0,1,0,0,19.8,14.17,14.17,0,0,0,2.41-3.23,13.6,13.6,0,0,0,1.06-2.51,14,14,0,0,0,0-8.32ZM4,16A12,12,0,0,1,16,4V28A12,12,0,0,1,4,16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var ConvertToCloud = /*#__PURE__*/React.forwardRef(function ConvertToCloud(_ref15, ref) {
  var children = _ref15.children,
    _ref15$size = _ref15.size,
    size = _ref15$size === void 0 ? 16 : _ref15$size,
    rest = _objectWithoutProperties(_ref15, _excluded15);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 12H19a4 4 0 010-8h.0835A4.7864 4.7864 0 0123 2a4.9816 4.9816 0 014.6543 3.2034A3.4667 3.4667 0 0130 8.5 3.5041 3.5041 0 0126.5 12zM19 6a2 2 0 000 4h7.5A1.5017 1.5017 0 0028 8.5a1.4855 1.4855 0 00-1.2778-1.4739L26.061 6.927l-.1616-.6487a2.9568 2.9568 0 00-5.4873-.7121L20.1143 6zM23 14l-5 5 1.4141 1.4141L22 17.8325V24H16v2h6a2.0025 2.0025 0 002-2V17.8325l2.5874 2.583L28 19zM2 20H12V22H2zM2 24H12V26H2zM2 28H12V30H2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Cookie = /*#__PURE__*/React.forwardRef(function Cookie(_ref16, ref) {
  var children = _ref16.children,
    _ref16$size = _ref16.size,
    size = _ref16$size === void 0 ? 16 : _ref16$size,
    rest = _objectWithoutProperties(_ref16, _excluded16);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "21",
    r: "2"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "20",
    r: "2"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: "13",
    cy: "10",
    r: "2"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: "14",
    cy: "15",
    r: "1"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "5",
    r: "2"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: "29",
    cy: "3",
    r: "1"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "23",
    r: "1"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30C8.3,30,2,23.7,2,16S8.3,2,16,2c0.1,0,0.2,0,0.3,0l1.4,0.1l-0.3,1.2c-0.1,0.4-0.2,0.9-0.2,1.3c0,2.8,2.2,5,5,5 c1,0,2-0.3,2.9-0.9l1.3,1.5c-0.4,0.4-0.6,0.9-0.6,1.4c0,1.3,1.3,2.4,2.7,1.9l1.2-0.5l0.2,1.3C30,14.9,30,15.5,30,16 C30,23.7,23.7,30,16,30z M15.3,4C9,4.4,4,9.6,4,16c0,6.6,5.4,12,12,12s12-5.4,12-12c0-0.1,0-0.3,0-0.4c-2.3,0.1-4.2-1.7-4.2-4 c0-0.1,0-0.1,0-0.2c-0.5,0.1-1,0.2-1.6,0.2c-3.9,0-7-3.1-7-7C15.2,4.4,15.2,4.2,15.3,4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Copy = /*#__PURE__*/React.forwardRef(function Copy(_ref17, ref) {
  var children = _ref17.children,
    _ref17$size = _ref17.size,
    size = _ref17$size === void 0 ? 16 : _ref17$size,
    rest = _objectWithoutProperties(_ref17, _excluded17);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M28,10V28H10V10H28m0-2H10a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V10a2,2,0,0,0-2-2Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M4,18H2V4A2,2,0,0,1,4,2H18V4H4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CopyFile = /*#__PURE__*/React.forwardRef(function CopyFile(_ref18, ref) {
  var children = _ref18.children,
    _ref18$size = _ref18.size,
    size = _ref18$size === void 0 ? 16 : _ref18$size,
    rest = _objectWithoutProperties(_ref18, _excluded18);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4,14.7l-6.1-6.1C21,8.2,20.5,8,20,8h-8c-1.1,0-2,0.9-2,2v18c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2V16.1 C28,15.6,27.8,15.1,27.4,14.7z M20,10l5.9,6H20V10z M12,28V10h6v6c0,1.1,0.9,2,2,2h6l0,10H12z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M6,18H4V4c0-1.1,0.9-2,2-2h14v2H6V18z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CopyLink = /*#__PURE__*/React.forwardRef(function CopyLink(_ref19, ref) {
  var children = _ref19.children,
    _ref19$size = _ref19.size,
    size = _ref19$size === void 0 ? 16 : _ref19$size,
    rest = _objectWithoutProperties(_ref19, _excluded19);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9474,19a4.9476,4.9476,0,0,1-3.4991-8.4465l5.1053-5.1043a4.9482,4.9482,0,0,1,6.9981,6.9976l-.5523.5526-1.4158-1.4129.5577-.5579a2.95,2.95,0,0,0-.0039-4.1653,3.02,3.02,0,0,0-4.17,0l-5.1047,5.104a2.9474,2.9474,0,0,0,0,4.1692,3.02,3.02,0,0,0,4.17,0l1.4143,1.4145A4.9176,4.9176,0,0,1,11.9474,19Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9474,17a4.9476,4.9476,0,0,1-3.4991-8.4465l.5526-.5526,1.4143,1.4146-.5526.5523a2.9476,2.9476,0,0,0,0,4.1689,3.02,3.02,0,0,0,4.17,0c.26-.26,4.7293-4.7293,5.1053-5.1045a2.951,2.951,0,0,0,0-4.1687,3.02,3.02,0,0,0-4.17,0L21.5536,3.449a4.9483,4.9483,0,0,1,6.9981,6.9978c-.3765.376-4.844,4.8428-5.1038,5.1035A4.9193,4.9193,0,0,1,19.9474,17Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M24,30H4a2.0021,2.0021,0,0,1-2-2V8A2.0021,2.0021,0,0,1,4,6H8V8H4V28H24V18h2V28A2.0021,2.0021,0,0,1,24,30Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Corn = /*#__PURE__*/React.forwardRef(function Corn(_ref20, ref) {
  var children = _ref20.children,
    _ref20$size = _ref20.size,
    size = _ref20$size === void 0 ? 16 : _ref20$size,
    rest = _objectWithoutProperties(_ref20, _excluded20);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M23,16c-.3374,0-.67.02-1,.0508V16C22,8.115,19.0435,2,16.5,2S11,8.115,11,16v5H6v3a6.0067,6.0067,0,0,0,6,6h3A11.0125,11.0125,0,0,0,26,19V16ZM13,16h2V14H13.0728a25.8942,25.8942,0,0,1,.5654-4H16V8H14.2c.81-2.4058,1.8149-3.7715,2.3-3.9863.66.2919,2.2842,2.7036,3.0654,6.9863H18v2h1.8442A29.1625,29.1625,0,0,1,20,16v.4263A11.0554,11.0554,0,0,0,13.79,21H13ZM12,28a4.0045,4.0045,0,0,1-4-4V23h4.7639A10.9033,10.9033,0,0,0,12,27Zm12-9a9.01,9.01,0,0,1-9,9H14V27a9.01,9.01,0,0,1,9-9h1Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Corner = /*#__PURE__*/React.forwardRef(function Corner(_ref21, ref) {
  var children = _ref21.children,
    _ref21$size = _ref21.size,
    size = _ref21$size === void 0 ? 16 : _ref21$size,
    rest = _objectWithoutProperties(_ref21, _excluded21);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M28,9H14V6H6v8H9V28h2V14h3V11H28ZM12,12H8V8h4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Coronavirus = /*#__PURE__*/React.forwardRef(function Coronavirus(_ref22, ref) {
  var children = _ref22.children,
    _ref22$size = _ref22.size,
    size = _ref22$size === void 0 ? 16 : _ref22$size,
    rest = _objectWithoutProperties(_ref22, _excluded22);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: "15.5",
    cy: "11.5",
    r: "1.5"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: "20.5",
    cy: "15.5",
    r: "1.5"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "1"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: "16.5",
    cy: "20.5",
    r: "1.5"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: "11.5",
    cy: "16.5",
    r: "1.5"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M28,13v2H25.9492a9.9476,9.9476,0,0,0-2.2143-5.3213l1.4367-1.4365,1.4143,1.4145L28,8.2427,23.7578,4l-1.414,1.4141,1.414,1.414-1.437,1.4365A9.9464,9.9464,0,0,0,17,6.0508V4h2V2H13V4h2V6.0508A9.9464,9.9464,0,0,0,9.6792,8.2646L8.2422,6.8281l1.414-1.414L8.2422,4,4,8.2427l1.4141,1.414L6.8284,8.2422,8.2651,9.6787A9.9476,9.9476,0,0,0,6.0508,15H4V13H2v6H4V17H6.0508a9.9476,9.9476,0,0,0,2.2143,5.3213L6.8284,23.7578,5.4141,22.3433,4,23.7573,8.2422,28l1.414-1.4141-1.414-1.414,1.437-1.4365A9.9464,9.9464,0,0,0,15,25.9492V28H13v2h6V28H17V25.9492a9.9464,9.9464,0,0,0,5.3208-2.2138l1.437,1.4365-1.414,1.414L23.7578,28,28,23.7573l-1.4141-1.414-1.4143,1.4145-1.4367-1.4365A9.9476,9.9476,0,0,0,25.9492,17H28v2h2V13ZM16,24a8,8,0,1,1,8-8A8.0092,8.0092,0,0,1,16,24Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Cost = /*#__PURE__*/React.forwardRef(function Cost(_ref23, ref) {
  var children = _ref23.children,
    _ref23$size = _ref23.size,
    size = _ref23$size === void 0 ? 16 : _ref23$size,
    rest = _objectWithoutProperties(_ref23, _excluded23);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M16,23a7,7,0,1,1,7-7A7.0078,7.0078,0,0,1,16,23Zm0-12a5,5,0,1,0,5,5A5.0057,5.0057,0,0,0,16,11Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M30,6.4141,28.5859,5l-3.35,3.35A12.0812,12.0812,0,0,0,23.65,6.7637L27,3.4141,25.5859,2,21.9766,5.6094A11.9792,11.9792,0,0,0,5.6094,21.9766L2,25.5859,3.4141,27l3.35-3.35A12.0812,12.0812,0,0,0,8.35,25.2363L5,28.5859,6.4141,30l3.6093-3.6094A11.9792,11.9792,0,0,0,26.3906,10.0234ZM16,26A10,10,0,1,1,26,16,10.0114,10.0114,0,0,1,16,26Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CostTotal = /*#__PURE__*/React.forwardRef(function CostTotal(_ref24, ref) {
  var children = _ref24.children,
    _ref24$size = _ref24.size,
    size = _ref24$size === void 0 ? 16 : _ref24$size,
    rest = _objectWithoutProperties(_ref24, _excluded24);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13H22V15H10zM10 18H22V20H10z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M30,6.4141,28.5859,5l-3.35,3.35A12.0812,12.0812,0,0,0,23.65,6.7637L27,3.4141,25.5859,2,21.9766,5.6094A11.9792,11.9792,0,0,0,5.6094,21.9766L2,25.5859,3.4141,27l3.35-3.35A12.0812,12.0812,0,0,0,8.35,25.2363L5,28.5859,6.4141,30l3.6093-3.6094A11.9792,11.9792,0,0,0,26.3906,10.0234ZM16,26A10,10,0,1,1,26,16,10.0114,10.0114,0,0,1,16,26Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Cough = /*#__PURE__*/React.forwardRef(function Cough(_ref25, ref) {
  var children = _ref25.children,
    _ref25$size = _ref25.size,
    size = _ref25$size === void 0 ? 16 : _ref25$size,
    rest = _objectWithoutProperties(_ref25, _excluded25);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M26,30H24V27H20a5.0055,5.0055,0,0,1-5-5V20.7207l-2.3162-.772a1,1,0,0,1-.5412-1.4631L15,13.7229V11a9.01,9.01,0,0,1,9-9h5V4H24a7.0078,7.0078,0,0,0-7,7v3a.9991.9991,0,0,1-.1426.5144l-2.3586,3.9312,1.8174.6057A1,1,0,0,1,17,20v2a3.0033,3.0033,0,0,0,3,3h5a1,1,0,0,1,1,1Z"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "23",
    r: "1"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: "6",
    cy: "20",
    r: "1"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: "6",
    cy: "26",
    r: "1"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: "3",
    cy: "17",
    r: "1"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: "3",
    cy: "29",
    r: "1"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: "3",
    cy: "23",
    r: "1"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M19 12H23V14H19z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Course = /*#__PURE__*/React.forwardRef(function Course(_ref26, ref) {
  var children = _ref26.children,
    _ref26$size = _ref26.size,
    size = _ref26$size === void 0 ? 16 : _ref26$size,
    rest = _objectWithoutProperties(_ref26, _excluded26);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M24,30H8a2.0023,2.0023,0,0,1-2-2V4A2.002,2.002,0,0,1,8,2H24a2.0023,2.0023,0,0,1,2,2V20.6182l-5-2.5-5,2.5V4H8V28H24V24h2v4A2.0027,2.0027,0,0,1,24,30ZM21,15.8818l3,1.5V4H18V17.3818Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Covariate = /*#__PURE__*/React.forwardRef(function Covariate(_ref27, ref) {
  var children = _ref27.children,
    _ref27$size = _ref27.size,
    size = _ref27$size === void 0 ? 16 : _ref27$size,
    rest = _objectWithoutProperties(_ref27, _excluded27);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: "8",
    cy: "16",
    r: "2"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: "14",
    cy: "8",
    r: "2"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: "28",
    cy: "12",
    r: "2"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "18",
    r: "2"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M30,3.4141,28.5859,2,4,26.5859V2H2V28a2,2,0,0,0,2,2H30V28H5.4141ZM4,28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CreateLink = /*#__PURE__*/React.forwardRef(function CreateLink(_ref28, ref) {
  var children = _ref28.children,
    _ref28$size = _ref28.size,
    size = _ref28$size === void 0 ? 16 : _ref28$size,
    rest = _objectWithoutProperties(_ref28, _excluded28);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M7,8v3h-2v-3h-3v-2h3v-3h2v3h3v2h-3ZM22.42,26.01l6.03-6.03h0c2.06-2.06,2.06-5.39,0-7.44s-5.39-2.06-7.44,0l1.41,1.41h0c1.27-1.27,3.34-1.27,4.62,0,1.27,1.27,1.27,3.34,0,4.62l-6.03,6.03h0c-1.27,1.27-3.34,1.27-4.62,0-1.27-1.27-1.27-3.34,0-4.62l-1.41-1.41c-.99.99-1.54,2.33-1.54,3.73,0,2.91,2.36,5.26,5.27,5.26,1.4,0,2.74-.55,3.72-1.54h0l-.01-.01ZM13.99,28.46l-1.41-1.41c-1.27,1.26-3.32,1.26-4.6,0-1.28-1.27-1.29-3.34-.02-4.62l6.03-6.03.02-.02c1.28-1.27,3.35-1.26,4.62.02s1.26,3.35-.02,4.62l1.41,1.41.03-.03c2.05-2.06,2.03-5.4-.03-7.44-2.06-2.05-5.4-2.03-7.44.03l-6.03,6.03c-.99.99-1.55,2.33-1.55,3.72,0,2.91,2.37,5.26,5.27,5.26,1.4,0,2.74-.55,3.72-1.54Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Credentials = /*#__PURE__*/React.forwardRef(function Credentials(_ref29, ref) {
  var children = _ref29.children,
    _ref29$size = _ref29.size,
    size = _ref29$size === void 0 ? 16 : _ref29$size,
    rest = _objectWithoutProperties(_ref29, _excluded29);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M16 22a4 4 0 10-4-4A4 4 0 0016 22zm0-6a2 2 0 11-2 2A2 2 0 0116 16zM14 6H18V8H14z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M24,2H8A2.002,2.002,0,0,0,6,4V28a2.0023,2.0023,0,0,0,2,2H24a2.0027,2.0027,0,0,0,2-2V4A2.0023,2.0023,0,0,0,24,2ZM20,28H12V26a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1Zm2,0V26a3,3,0,0,0-3-3H13a3,3,0,0,0-3,3v2H8V4H24V28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Critical = /*#__PURE__*/React.forwardRef(function Critical(_ref30, ref) {
  var children = _ref30.children,
    _ref30$size = _ref30.size,
    size = _ref30$size === void 0 ? 16 : _ref30$size,
    rest = _objectWithoutProperties(_ref30, _excluded30);
  if (size === "glyph" || size === "glyph" || size === "glyphpx") {
    return /*#__PURE__*/React.createElement(Icon, _objectSpread({
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor"
    }, rest), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
      d: "M12.887 11.4727a5.9936 5.9936 0 00-8.36-8.3594zM3.113 4.5273a5.9936 5.9936 0 008.36 8.3594z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, rest), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M12.887 11.4727a5.9936 5.9936 0 00-8.36-8.3594zM3.113 4.5273a5.9936 5.9936 0 008.36 8.3594z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CriticalSeverity = /*#__PURE__*/React.forwardRef(function CriticalSeverity(_ref31, ref) {
  var children = _ref31.children,
    _ref31$size = _ref31.size,
    size = _ref31$size === void 0 ? 16 : _ref31$size,
    rest = _objectWithoutProperties(_ref31, _excluded31);
  if (size === "glyph" || size === "glyph" || size === "glyphpx") {
    return /*#__PURE__*/React.createElement(Icon, _objectSpread({
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor"
    }, rest), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
      d: "M13 13L3 13 3 3 13 13z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, rest), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M13 13L3 13 3 3 13 13z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Crop = /*#__PURE__*/React.forwardRef(function Crop(_ref32, ref) {
  var children = _ref32.children,
    _ref32$size = _ref32.size,
    size = _ref32$size === void 0 ? 16 : _ref32$size,
    rest = _objectWithoutProperties(_ref32, _excluded32);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M25,20H23V9H12V7H23a2,2,0,0,1,2,2Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M9,23V2H7V7H2V9H7V23a2,2,0,0,0,2,2H23v5h2V25h5V23Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CropGrowth = /*#__PURE__*/React.forwardRef(function CropGrowth(_ref33, ref) {
  var children = _ref33.children,
    _ref33$size = _ref33.size,
    size = _ref33$size === void 0 ? 16 : _ref33$size,
    rest = _objectWithoutProperties(_ref33, _excluded33);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M26,13a4.0045,4.0045,0,0,0,4-4V6H27a3.979,3.979,0,0,0-2.7468,1.1064A6.0041,6.0041,0,0,0,19,4H16V7a6.0066,6.0066,0,0,0,6,6h1V26H11V21h1a4.0045,4.0045,0,0,0,4-4V14H13a3.979,3.979,0,0,0-2.7468,1.1064A6.0041,6.0041,0,0,0,5,12H2v3a6.0066,6.0066,0,0,0,6,6H9v5H2v2H30V26H25V13Zm-1-3a2.002,2.002,0,0,1,2-2h1V9a2.002,2.002,0,0,1-2,2H25ZM11,18a2.002,2.002,0,0,1,2-2h1v1a2.002,2.002,0,0,1-2,2H11ZM9,19H8a4.0045,4.0045,0,0,1-4-4V14H5a4.0045,4.0045,0,0,1,4,4Zm14-8H22a4.0045,4.0045,0,0,1-4-4V6h1a4.0045,4.0045,0,0,1,4,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CropHealth = /*#__PURE__*/React.forwardRef(function CropHealth(_ref34, ref) {
  var children = _ref34.children,
    _ref34$size = _ref34.size,
    size = _ref34$size === void 0 ? 16 : _ref34$size,
    rest = _objectWithoutProperties(_ref34, _excluded34);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M2 28H10V30H2zM17 29a1 1 0 01-.7808-.3752L12.52 24H2V22H13a1 1 0 01.7808.3752l3.146 3.9322 5.2412-7.8621A1 1 0 0123.8 18.4L26.5 22H30v2H26a.9991.9991 0 01-.8-.4l-2.1523-2.8694-5.2159 7.824a.9986.9986 0 01-.7885.4443zM11 16V11h1a4.0045 4.0045 0 004-4V4H13a3.9779 3.9779 0 00-2.7468 1.1067A6.0034 6.0034 0 005 2H2V5a6.0066 6.0066 0 006 6H9v5H2v2H16V16zM13 6h1V7a2.002 2.002 0 01-2 2H11V8A2.002 2.002 0 0113 6zM8 9A4.0045 4.0045 0 014 5V4H5A4.0045 4.0045 0 019 8V9z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var WatsonHealthCrossReference = /*#__PURE__*/React.forwardRef(function WatsonHealthCrossReference(_ref35, ref) {
  var children = _ref35.children,
    _ref35$size = _ref35.size,
    size = _ref35$size === void 0 ? 16 : _ref35$size,
    rest = _objectWithoutProperties(_ref35, _excluded35);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M11 24H15V26H11zM5 24H9V26H5zM23 24H27V26H23zM17 24H21V26H17zM9 22a4.92 4.92 0 014-2h6a5.22 5.22 0 014 2h2.3A6.87 6.87 0 0019 18H13a6.87 6.87 0 00-6.3 4zM24 28H26V30H24zM6 28H8V30H6zM16 16a7 7 0 117-7A7 7 0 0116 16zM16 4a5 5 0 00-5 5A5 5 0 0021 9 5 5 0 0016 4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CrossTab = /*#__PURE__*/React.forwardRef(function CrossTab(_ref36, ref) {
  var children = _ref36.children,
    _ref36$size = _ref36.size,
    size = _ref36$size === void 0 ? 16 : _ref36$size,
    rest = _objectWithoutProperties(_ref36, _excluded36);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H10A2.0023,2.0023,0,0,0,8,4V7H4A2.0023,2.0023,0,0,0,2,9V28a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2ZM10,4H28V7H10ZM28,14H20V9h8ZM10,21V16h8v5Zm8,2v5H10V23ZM8,21H4V16H8ZM18,9v5H10V9Zm2,7h8v5H20ZM8,9v5H4V9ZM4,23H8v5H4Zm16,5V23h8v5Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Crossroads = /*#__PURE__*/React.forwardRef(function Crossroads(_ref37, ref) {
  var children = _ref37.children,
    _ref37$size = _ref37.size,
    size = _ref37$size === void 0 ? 16 : _ref37$size,
    rest = _objectWithoutProperties(_ref37, _excluded37);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5859,6.5859A1.9862,1.9862,0,0,0,25.1719,6H17V2H15V12H6.8281a1.9862,1.9862,0,0,0-1.414.5859L2,16l3.4141,3.4141A1.9862,1.9862,0,0,0,6.8281,20H15V30h2V14h8.1719a1.9862,1.9862,0,0,0,1.414-.5859L30,10ZM6.8281,18l-2-2,2-2H15v4Zm18.3438-6H17V8h8.1719l2,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CrowdReport = /*#__PURE__*/React.forwardRef(function CrowdReport(_ref38, ref) {
  var children = _ref38.children,
    _ref38$size = _ref38.size,
    size = _ref38$size === void 0 ? 16 : _ref38$size,
    rest = _objectWithoutProperties(_ref38, _excluded38);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M16.832,19.5547l-1.664-1.1094L17.4648,15H20V10H12v5h2v2H12a2.0021,2.0021,0,0,1-2-2V10a2.0021,2.0021,0,0,1,2-2h8a2.0021,2.0021,0,0,1,2,2v5a2.0021,2.0021,0,0,1-2,2H18.5352Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30,7.5645,20.0513c-.0479-.0571-.3482-.4515-.3482-.4515A10.8888,10.8888,0,0,1,5,13a11,11,0,0,1,22,0,10.8844,10.8844,0,0,1-2.2148,6.5973l-.0015.0025s-.3.3944-.3447.4474ZM8.8125,18.395c.001.0007.2334.3082.2866.3744L16,26.9079l6.91-8.15c.0439-.0552.2783-.3649.2788-.3657A8.901,8.901,0,0,0,25,13,9,9,0,0,0,7,13a8.9054,8.9054,0,0,0,1.8125,5.395Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CrowdReportFilled = /*#__PURE__*/React.forwardRef(function CrowdReportFilled(_ref39, ref) {
  var children = _ref39.children,
    _ref39$size = _ref39.size,
    size = _ref39$size === void 0 ? 16 : _ref39$size,
    rest = _objectWithoutProperties(_ref39, _excluded39);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M16.832,19.5547l-1.664-1.1094L17.4648,15H20V10H12v5h2v2H12a2.0021,2.0021,0,0,1-2-2V10a2.0021,2.0021,0,0,1,2-2h8a2.0021,2.0021,0,0,1,2,2v5a2.0021,2.0021,0,0,1-2,2H18.5352Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A11.0134,11.0134,0,0,0,5,13a10.8885,10.8885,0,0,0,2.2163,6.6s.3.3945.3482.4517L16,30l8.439-9.9526c.0444-.0533.3447-.4478.3447-.4478l.0015-.0024A10.8846,10.8846,0,0,0,27,13,11.0134,11.0134,0,0,0,16,2Zm6,13a2.0023,2.0023,0,0,1-2,2H18.5352L16.832,19.5547l-1.664-1.1094L17.4648,15H20V10H12v5h2v2H12a2.0023,2.0023,0,0,1-2-2V10a2.0023,2.0023,0,0,1,2-2h8a2.0023,2.0023,0,0,1,2,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Csv = /*#__PURE__*/React.forwardRef(function Csv(_ref40, ref) {
  var children = _ref40.children,
    _ref40$size = _ref40.size,
    size = _ref40$size === void 0 ? 16 : _ref40$size,
    rest = _objectWithoutProperties(_ref40, _excluded40);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M28 9L26 22 24 9 22 9 24.516 23 27.484 23 30 9 28 9zM18 23H12V21h6V17H14a2.002 2.002 0 01-2-2V11a2.002 2.002 0 012-2h6v2H14v4h4a2.002 2.002 0 012 2v4A2.002 2.002 0 0118 23zM10 23H4a2.0023 2.0023 0 01-2-2V11A2.002 2.002 0 014 9h6v2H4V21h6z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var QCU1 = /*#__PURE__*/React.forwardRef(function QCU1(_ref41, ref) {
  var children = _ref41.children,
    _ref41$size = _ref41.size,
    size = _ref41$size === void 0 ? 16 : _ref41$size,
    rest = _objectWithoutProperties(_ref41, _excluded41);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M10 23H5a2 2 0 01-2-2V15a2 2 0 012-2h5v2H5v6h5zM18 23H14a2 2 0 01-2-2V9h2V21h4V9h2V21A2 2 0 0118 23zM27 21L27 9.01 22 9.01 22 11.01 25 11.01 25 21 22 21 22 23 30 23 30 21 27 21z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var QCU3 = /*#__PURE__*/React.forwardRef(function QCU3(_ref42, ref) {
  var children = _ref42.children,
    _ref42$size = _ref42.size,
    size = _ref42$size === void 0 ? 16 : _ref42$size,
    rest = _objectWithoutProperties(_ref42, _excluded42);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M10 23H5a2 2 0 01-2-2V15a2 2 0 012-2h5v2H5v6h5zM18 23H14a2 2 0 01-2-2V9h2V21h4V9h2V21A2 2 0 0118 23zM28 9H22v2h6v4H23v2h5v4H22v2h6a2 2 0 002-2V11A2 2 0 0028 9z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Cube = /*#__PURE__*/React.forwardRef(function Cube(_ref43, ref) {
  var children = _ref43.children,
    _ref43$size = _ref43.size,
    size = _ref43$size === void 0 ? 16 : _ref43$size,
    rest = _objectWithoutProperties(_ref43, _excluded43);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5039,8.1362l-12-7a1,1,0,0,0-1.0078,0l-12,7A1,1,0,0,0,3,9V23a1,1,0,0,0,.4961.8638l12,7a1,1,0,0,0,1.0078,0l12-7A1,1,0,0,0,29,23V9A1,1,0,0,0,28.5039,8.1362ZM16,3.1577,26.0156,9,16,14.8423,5.9844,9ZM5,10.7412l10,5.833V28.2588L5,22.4258ZM17,28.2588V16.5742l10-5.833V22.4258Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CubeView = /*#__PURE__*/React.forwardRef(function CubeView(_ref44, ref) {
  var children = _ref44.children,
    _ref44$size = _ref44.size,
    size = _ref44$size === void 0 ? 16 : _ref44$size,
    rest = _objectWithoutProperties(_ref44, _excluded44);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7769,15.4785A8.64,8.64,0,0,0,16,10a8.64,8.64,0,0,0-7.7769,5.4785L8,16l.2231.5215A8.64,8.64,0,0,0,16,22a8.64,8.64,0,0,0,7.7769-5.4785L24,16ZM16,20a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,20Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5039,8.1362l-12-7a1,1,0,0,0-1.0078,0l-12,7A1,1,0,0,0,3,9V23a1,1,0,0,0,.4961.8638l12,7a1,1,0,0,0,1.0078,0l12-7A1,1,0,0,0,29,23V9A1,1,0,0,0,28.5039,8.1362ZM27,22.4258,16,28.8423,5,22.4258V9.5742L16,3.1577,27,9.5742Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Currency = /*#__PURE__*/React.forwardRef(function Currency(_ref45, ref) {
  var children = _ref45.children,
    _ref45$size = _ref45.size,
    size = _ref45$size === void 0 ? 16 : _ref45$size,
    rest = _objectWithoutProperties(_ref45, _excluded45);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M21,12V10H17V7H15v3H13a2.002,2.002,0,0,0-2,2v3a2.002,2.002,0,0,0,2,2h6v3H11v2h4v3h2V22h2a2.0023,2.0023,0,0,0,2-2V17a2.002,2.002,0,0,0-2-2H13V12Z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M16,4A12,12,0,1,1,4,16,12.0353,12.0353,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14.0412,14.0412,0,0,0,16,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CurrencyBaht = /*#__PURE__*/React.forwardRef(function CurrencyBaht(_ref46, ref) {
  var children = _ref46.children,
    _ref46$size = _ref46.size,
    size = _ref46$size === void 0 ? 16 : _ref46$size,
    rest = _objectWithoutProperties(_ref46, _excluded46);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4023,15.6426A4.9727,4.9727,0,0,0,23,12V11a5.0059,5.0059,0,0,0-5-5H17V3H15V6H10V26h5v3h2V26h2a5.0059,5.0059,0,0,0,5-5V20A4.9834,4.9834,0,0,0,21.4023,15.6426ZM12,8h6a3.0033,3.0033,0,0,1,3,3v1a3.0033,3.0033,0,0,1-3,3H12ZM22,21a3.0033,3.0033,0,0,1-3,3H12V17h7a3.0033,3.0033,0,0,1,3,3Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CurrencyDollar = /*#__PURE__*/React.forwardRef(function CurrencyDollar(_ref47, ref) {
  var children = _ref47.children,
    _ref47$size = _ref47.size,
    size = _ref47$size === void 0 ? 16 : _ref47$size,
    rest = _objectWithoutProperties(_ref47, _excluded47);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M23,20.5151c0-4.6152-3.78-5.1411-6.8171-5.563-3.31-.4609-5.1829-.86-5.1829-3.71C11,8.8491,13.5071,8,15.6538,8a6.7538,6.7538,0,0,1,5.5681,2.6279l1.5562-1.2558A8.6508,8.6508,0,0,0,17,6.0962V3H15V6.022c-3.6152.2192-6,2.26-6,5.22,0,4.73,3.83,5.2627,6.9075,5.69C19.16,17.3848,21,17.7744,21,20.5151,21,23.5474,17.8674,24,16,24c-3.4294,0-4.8782-.9639-6.2219-2.6279L8.2219,22.6279A8.4382,8.4382,0,0,0,15,25.9648V29h2V25.9551C20.7256,25.6509,23,23.6279,23,20.5151Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CurrencyEuro = /*#__PURE__*/React.forwardRef(function CurrencyEuro(_ref48, ref) {
  var children = _ref48.children,
    _ref48$size = _ref48.size,
    size = _ref48$size === void 0 ? 16 : _ref48$size,
    rest = _objectWithoutProperties(_ref48, _excluded48);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M17,26c-3.6162,0-6.3328-2.2974-7.4456-6H19V18H9.1321A15.2782,15.2782,0,0,1,9,16c0-.33.01-.6641.0259-1H19V13H9.2371C9.8447,9.3525,11.81,6,17,6c3.8533,0,5.5315,1.6465,7.1282,4.4893l1.7436-.9786C24.2649,6.6484,22.0779,4,17,4,10.6448,4,7,8.374,7,16c0,7.0654,4.1121,12,10,12,5.0779,0,7.2649-2.6484,8.8718-5.5107l-1.7436-.9786C22.5315,24.3535,20.8533,26,17,26Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CurrencyLira = /*#__PURE__*/React.forwardRef(function CurrencyLira(_ref49, ref) {
  var children = _ref49.children,
    _ref49$size = _ref49.size,
    size = _ref49$size === void 0 ? 16 : _ref49$size,
    rest = _objectWithoutProperties(_ref49, _excluded49);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M23,19a6.0066,6.0066,0,0,1-6,6H13V18.1079L21.2139,15V13L13,16.1079v-3L21.2139,10V8L13,11.1079V5H11v6.8647L8,13v2l3-1.1353v3L8,18v2l3-1.1353V27h6a8.0092,8.0092,0,0,0,8-8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CurrencyPound = /*#__PURE__*/React.forwardRef(function CurrencyPound(_ref50, ref) {
  var children = _ref50.children,
    _ref50$size = _ref50.size,
    size = _ref50$size === void 0 ? 16 : _ref50$size,
    rest = _objectWithoutProperties(_ref50, _excluded50);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4531,25A8.7775,8.7775,0,0,0,14,20a10.6,10.6,0,0,0-.18-2H22V16H13.2175c-.0842-.2109-.17-.4194-.2556-.624A9.8586,9.8586,0,0,1,12,11a4.792,4.792,0,0,1,5-5,6.1234,6.1234,0,0,1,5.2222,2.6279l1.5556-1.2558A8.11,8.11,0,0,0,17,4a6.7781,6.7781,0,0,0-7,7,11.65,11.65,0,0,0,1.0559,5H8v2h3.7729A8.209,8.209,0,0,1,12,20c0,2.5234-1.4858,5-3,5v2H24V25Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CurrencyRuble = /*#__PURE__*/React.forwardRef(function CurrencyRuble(_ref51, ref) {
  var children = _ref51.children,
    _ref51$size = _ref51.size,
    size = _ref51$size === void 0 ? 16 : _ref51$size,
    rest = _objectWithoutProperties(_ref51, _excluded51);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M19,4H10V15H7v2h3v3H7v2h3v6h2V22h9V20H12V17h7a6.0067,6.0067,0,0,0,6-6V10A6.0067,6.0067,0,0,0,19,4Zm4,7a4.0045,4.0045,0,0,1-4,4H12V6h7a4.0045,4.0045,0,0,1,4,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CurrencyRupee = /*#__PURE__*/React.forwardRef(function CurrencyRupee(_ref52, ref) {
  var children = _ref52.children,
    _ref52$size = _ref52.size,
    size = _ref52$size === void 0 ? 16 : _ref52$size,
    rest = _objectWithoutProperties(_ref52, _excluded52);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M24,7V5H8V7h5.5a4.4906,4.4906,0,0,1,4.45,4H8v2h9.95A4.4906,4.4906,0,0,1,13.5,17H8v2.3452L17.6169,28l1.3379-1.4863L10.606,19H13.5a6.5041,6.5041,0,0,0,6.4746-6H24V11H19.9746A6.4719,6.4719,0,0,0,18.18,7Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CurrencyShekel = /*#__PURE__*/React.forwardRef(function CurrencyShekel(_ref53, ref) {
  var children = _ref53.children,
    _ref53$size = _ref53.size,
    size = _ref53$size === void 0 ? 16 : _ref53$size,
    rest = _objectWithoutProperties(_ref53, _excluded53);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M9,27H7V5h8a5.0057,5.0057,0,0,1,5,5V22H18V10a3.0033,3.0033,0,0,0-3-3H9Z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M20,27H12V10h2V25h6a3.0033,3.0033,0,0,0,3-3V5h2V22A5.0057,5.0057,0,0,1,20,27Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CurrencyWon = /*#__PURE__*/React.forwardRef(function CurrencyWon(_ref54, ref) {
  var children = _ref54.children,
    _ref54$size = _ref54.size,
    size = _ref54$size === void 0 ? 16 : _ref54$size,
    rest = _objectWithoutProperties(_ref54, _excluded54);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M28 14L28 12 23.045 12 24 5 22 5 20 23 17 8 15 8 12 23 10 5 8 5 8.955 12 4 12 4 14 9.227 14 9.636 17 4 17 4 19 9.909 19 11 27 13 27 16 12 19 27 21 27 22.091 19 28 19 28 17 22.364 17 22.773 14 28 14z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CurrencyYen = /*#__PURE__*/React.forwardRef(function CurrencyYen(_ref55, ref) {
  var children = _ref55.children,
    _ref55$size = _ref55.size,
    size = _ref55$size === void 0 ? 16 : _ref55$size,
    rest = _objectWithoutProperties(_ref55, _excluded55);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M24.271 5L22 5 16 16 10 5 7.729 5 13.794 16 8 16 8 18 15 18 15 21 8 21 8 23 15 23 15 27 17 27 17 23 24 23 24 21 17 21 17 18 24 18 24 16 18.206 16 24.271 5z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Cursor_1 = /*#__PURE__*/React.forwardRef(function Cursor_1(_ref56, ref) {
  var children = _ref56.children,
    _ref56$size = _ref56.size,
    size = _ref56$size === void 0 ? 16 : _ref56$size,
    rest = _objectWithoutProperties(_ref56, _excluded56);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M23,28a1,1,0,0,1-.71-.29l-6.13-6.14-3.33,5a1,1,0,0,1-1,.44,1,1,0,0,1-.81-.7l-6-20A1,1,0,0,1,6.29,5l20,6a1,1,0,0,1,.7.81,1,1,0,0,1-.44,1l-5,3.33,6.14,6.13a1,1,0,0,1,0,1.42l-4,4A1,1,0,0,1,23,28Zm0-2.41L25.59,23l-7.16-7.15,5.25-3.5L7.49,7.49l4.86,16.19,3.5-5.25Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Cursor_2 = /*#__PURE__*/React.forwardRef(function Cursor_2(_ref57, ref) {
  var children = _ref57.children,
    _ref57$size = _ref57.size,
    size = _ref57$size === void 0 ? 16 : _ref57$size,
    rest = _objectWithoutProperties(_ref57, _excluded57);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M27.34,12.06l-22-8A1,1,0,0,0,4.06,5.34l8,22A1,1,0,0,0,13,28h0a1,1,0,0,0,.93-.63l3.84-9.6,9.6-3.84a1,1,0,0,0,0-1.87Zm-10.71,4h0l-.4.16-.16.4h0L13,24.2,6.67,6.67,24.2,13Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Customer = /*#__PURE__*/React.forwardRef(function Customer(_ref58, ref) {
  var children = _ref58.children,
    _ref58$size = _ref58.size,
    size = _ref58$size === void 0 ? 16 : _ref58$size,
    rest = _objectWithoutProperties(_ref58, _excluded58);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7554 21.3447c-.1899-.2188-.4656-.3447-.7554-.3447h-2v-2c0-1.1025-.8972-2-2-2h-4c-1.1028 0-2 .8975-2 2v2h-2c-.2898 0-.5654.126-.7554.3447-.1899.2192-.2756.5098-.2346.7969l1 7c.0703.4922.4924.8584.99.8584h10c.4976 0 .9197-.3662.99-.8584l1-7c.041-.2871-.0447-.5776-.2346-.7969zm-8.7554-2.3447h4v2h-4v-2zm6.1328 9h-8.2656l-.7141-5h9.6938l-.7141 5zM10 20H12V30H10z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7808 17.875l-1.9072-2.3838-1.4419-3.6055c-.4585-1.1455-1.5518-1.8857-2.7856-1.8857h-5.646c-1.6543 0-3 1.3457-3 3v7c0 1.1025.897 2 2 2h1v8h2v-10h-3v-7c0-.5518.4487-1 1-1h5.646c.4111 0 .7759.2471.9282.6289l1.645 3.9961 2 2.5 1.5615-1.25zM4 5c0-2.2056 1.7944-4 4-4s4 1.7944 4 4c0 2.2056-1.7944 4-4 4s-4-1.7944-4-4zm2 0c0 1.1028.897 2 2 2s2-.8972 2-2c0-1.1028-.897-2-2-2s-2 .8972-2 2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CustomerService = /*#__PURE__*/React.forwardRef(function CustomerService(_ref59, ref) {
  var children = _ref59.children,
    _ref59$size = _ref59.size,
    size = _ref59$size === void 0 ? 16 : _ref59$size,
    rest = _objectWithoutProperties(_ref59, _excluded59);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M26 30h-2v-5c-.0033-2.7601-2.2399-4.9967-5-5h-6c-2.7601.0033-4.9967 2.2399-5 5v5h-2v-5c.0045-3.8641 3.1359-6.9955 7-7h6c3.8641.0045 6.9955 3.1359 7 7v5zM22 6v4c0 1.1025-.8972 2-2 2h-1c-.5522 0-1 .4478-1 1s.4478 1 1 1h1c2.2056 0 4-1.7944 4-4v-4h-2zM16 16c-3.8599 0-7-3.1401-7-7S12.1401 2 16 2c1.9885 0 3.8901.8503 5.2173 2.3329l-1.4902 1.334c-.9482-1.0593-2.3066-1.6669-3.7271-1.6669-2.7571 0-5 2.243-5 5s2.2429 5 5 5v2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Cut = /*#__PURE__*/React.forwardRef(function Cut(_ref60, ref) {
  var children = _ref60.children,
    _ref60$size = _ref60.size,
    size = _ref60$size === void 0 ? 16 : _ref60$size,
    rest = _objectWithoutProperties(_ref60, _excluded60);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5,19.63,20.24,16l6.26-3.63a5,5,0,0,0-1.21-9.2A5.19,5.19,0,0,0,24,3a5,5,0,0,0-4.33,7.53,5,5,0,0,0,2.39,2.1l-3.82,2.21L4,6.6,3,8.34,16.24,16,3,23.68l1,1.74,14.24-8.26,3.82,2.21a5,5,0,0,0-2.39,2.1A5,5,0,0,0,24,29a5.19,5.19,0,0,0,1.29-.17,5,5,0,0,0,1.21-9.2ZM21.4,9.53a3,3,0,0,1,1.1-4.12,3,3,0,0,1,4.1,1.11,3,3,0,0,1-1.1,4.11h0A3,3,0,0,1,21.4,9.53Zm5.2,16a3,3,0,0,1-4.1,1.11,3,3,0,0,1-1.1-4.12,3,3,0,0,1,4.1-1.1h0A3,3,0,0,1,26.6,25.48Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var WatsonHealthCutInHalf = /*#__PURE__*/React.forwardRef(function WatsonHealthCutInHalf(_ref61, ref) {
  var children = _ref61.children,
    _ref61$size = _ref61.size,
    size = _ref61$size === void 0 ? 16 : _ref61$size,
    rest = _objectWithoutProperties(_ref61, _excluded61);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4H4A2.0023,2.0023,0,0,0,2,6V26a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V6A2.0023,2.0023,0,0,0,28,4ZM4,6H16V26H4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CutOut = /*#__PURE__*/React.forwardRef(function CutOut(_ref62, ref) {
  var children = _ref62.children,
    _ref62$size = _ref62.size,
    size = _ref62$size === void 0 ? 16 : _ref62$size,
    rest = _objectWithoutProperties(_ref62, _excluded62);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M19.05 13.7326L18.05 12 7.928 17.8457 6.9312 17.27a2.9524 2.9524 0 00.6672-.769A3 3 0 103.5 17.5986l2.428 1.4019L3.5 20.4023a3.0342 3.0342 0 103.4407.3223l.987-.5693L14.5914 24l1-1.7294-5.6634-3.27zM4.0344 15.26a1 1 0 11.4658.6069A.9929.9929 0 014.0344 15.26zM4.9988 22a1 1 0 11-.8645 1.5A1 1 0 014.9988 22zM17 26H21V28H17zM10 26H14V28H10z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M28,28H24V26h4V4H7V8H5V4A2.0023,2.0023,0,0,1,7,2H28a2.0023,2.0023,0,0,1,2,2V26A2.0023,2.0023,0,0,1,28,28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var QCY = /*#__PURE__*/React.forwardRef(function QCY(_ref63, ref) {
  var children = _ref63.children,
    _ref63$size = _ref63.size,
    size = _ref63$size === void 0 ? 16 : _ref63$size,
    rest = _objectWithoutProperties(_ref63, _excluded63);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M15 23H10a2 2 0 01-2-2V15a2 2 0 012-2h5v2H10v6h5zM24 9L22 9 20 16 18 9 16 9 19 18 19 23 21 23 21 18 24 9z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Cyclist = /*#__PURE__*/React.forwardRef(function Cyclist(_ref64, ref) {
  var children = _ref64.children,
    _ref64$size = _ref64.size,
    size = _ref64$size === void 0 ? 16 : _ref64$size,
    rest = _objectWithoutProperties(_ref64, _excluded64);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M25 30a6 6 0 116-6A6.0069 6.0069 0 0125 30zm0-10a4 4 0 104 4A4.0045 4.0045 0 0025 20zM7 30a6 6 0 116-6A6.0069 6.0069 0 017 30zM7 20a4 4 0 104 4A4.0045 4.0045 0 007 20z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M17 27H15V20.4139L9.5849 15a2.003 2.003 0 010-2.8292l4.5859-4.5859a2.0024 2.0024 0 012.8286 0L21.414 12H27v1.9993L20.5853 14l-5-5L11 13.5849l6 6zM21.5 8A3.5 3.5 0 1125 4.5 3.5042 3.5042 0 0121.5 8zm0-5A1.5 1.5 0 1023 4.5 1.5017 1.5017 0 0021.5 3z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var QCZ = /*#__PURE__*/React.forwardRef(function QCZ(_ref65, ref) {
  var children = _ref65.children,
    _ref65$size = _ref65.size,
    size = _ref65$size === void 0 ? 16 : _ref65$size,
    rest = _objectWithoutProperties(_ref65, _excluded65);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M14 23H9a2 2 0 01-2-2V15a2 2 0 012-2h5v2H9v6h5zM24 9L16 9 16 11 22 11 16 21 16 23 24 23 24 21 18 21 24 11 24 9z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Dashboard = /*#__PURE__*/React.forwardRef(function Dashboard(_ref66, ref) {
  var children = _ref66.children,
    _ref66$size = _ref66.size,
    size = _ref66$size === void 0 ? 16 : _ref66$size,
    rest = _objectWithoutProperties(_ref66, _excluded66);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M24 21H26V26H24zM20 16H22V26H20zM11 26a5.0059 5.0059 0 01-5-5H8a3 3 0 103-3V16a5 5 0 010 10z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H4A2.002,2.002,0,0,0,2,4V28a2.0023,2.0023,0,0,0,2,2H28a2.0027,2.0027,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2Zm0,9H14V4H28ZM12,4v7H4V4ZM4,28V13H28.0007l.0013,15Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var DashboardReference = /*#__PURE__*/React.forwardRef(function DashboardReference(_ref67, ref) {
  var children = _ref67.children,
    _ref67$size = _ref67.size,
    size = _ref67$size === void 0 ? 16 : _ref67$size,
    rest = _objectWithoutProperties(_ref67, _excluded67);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM24 21H26V26H24zM20 16H22V26H20zM16 18H18V26H16z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H4A2.002,2.002,0,0,0,2,4V16H4V13H28.001l.001,15H16v2H28a2.0027,2.0027,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2ZM12,11H4V4h8Zm2,0V4H28l.0007,7Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Data_1 = /*#__PURE__*/React.forwardRef(function Data_1(_ref68, ref) {
  var children = _ref68.children,
    _ref68$size = _ref68.size,
    size = _ref68$size === void 0 ? 16 : _ref68$size,
    rest = _objectWithoutProperties(_ref68, _excluded68);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M15 6H28V8H15zM15 24H28V26H15zM4 15H17V17H4zM7 11a4 4 0 114-4A4 4 0 017 11zM7 5A2 2 0 109 7 2 2 0 007 5zM7 29a4 4 0 114-4A4 4 0 017 29zm0-6a2 2 0 102 2A2 2 0 007 23zM25 20a4 4 0 114-4A4 4 0 0125 20zm0-6a2 2 0 102 2A2 2 0 0025 14z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Data_2 = /*#__PURE__*/React.forwardRef(function Data_2(_ref69, ref) {
  var children = _ref69.children,
    _ref69$size = _ref69.size,
    size = _ref69$size === void 0 ? 16 : _ref69$size,
    rest = _objectWithoutProperties(_ref69, _excluded69);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M4 6H15V8H4zM18 6H28V8H18zM21 12H28V14H21zM11 12H18V14H11zM4 12H8V14H4zM4 18H28V20H4zM4 24H21V26H4zM24 24H28V26H24z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var DataBase = /*#__PURE__*/React.forwardRef(function DataBase(_ref70, ref) {
  var children = _ref70.children,
    _ref70$size = _ref70.size,
    size = _ref70$size === void 0 ? 16 : _ref70$size,
    rest = _objectWithoutProperties(_ref70, _excluded70);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M24,3H8A2,2,0,0,0,6,5V27a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V5A2,2,0,0,0,24,3Zm0,2v6H8V5ZM8,19V13H24v6Zm0,8V21H24v6Z"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "8",
    r: "1"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "16",
    r: "1"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "24",
    r: "1"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var DataBaseAlt = /*#__PURE__*/React.forwardRef(function DataBaseAlt(_ref71, ref) {
  var children = _ref71.children,
    _ref71$size = _ref71.size,
    size = _ref71$size === void 0 ? 16 : _ref71$size,
    rest = _objectWithoutProperties(_ref71, _excluded71);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M7 8H12V10H7zM7 12H12V14H7zM7 16H12V18H7zM20 8H25V10H20zM20 12H25V14H20zM20 16H25V18H20z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4H4A2.0023,2.0023,0,0,0,2,6V28a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V6A2.0023,2.0023,0,0,0,28,4ZM4,6H15V28H4ZM17,28V6H28V28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var DataCategorical = /*#__PURE__*/React.forwardRef(function DataCategorical(_ref72, ref) {
  var children = _ref72.children,
    _ref72$size = _ref72.size,
    size = _ref72$size === void 0 ? 16 : _ref72$size,
    rest = _objectWithoutProperties(_ref72, _excluded72);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M29 30h-10c-.5522 0-1-.4478-1-1v-10c0-.5522.4478-1 1-1h10c.5522 0 1 .4478 1 1v10c0 .5522-.4478 1-1 1zm-9-2h8v-8h-8v8zM8 30c-3.3083 0-6-2.6917-6-6s2.6917-6 6-6 6 2.6917 6 6-2.6917 6-6 6zm0-10c-2.2056 0-4 1.7944-4 4s1.7944 4 4 4 4-1.7944 4-4-1.7944-4-4-4zM22 14h-12c-.3604 0-.6926-.1938-.8701-.5073s-.1729-.6982.0127-1.0072L15.1446 2.4822c.1937-.3229.5246-.4822.8554-.4822s.6617.1593.8554.4822l6.002 10.0033c.1855.309.1902.6937.0127 1.0072s-.5098.5073-.8701.5073zm-10.2339-2h8.4678l-4.2339-7.0564-4.2339 7.0564z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var DataCenter = /*#__PURE__*/React.forwardRef(function DataCenter(_ref73, ref) {
  var children = _ref73.children,
    _ref73$size = _ref73.size,
    size = _ref73$size === void 0 ? 16 : _ref73$size,
    rest = _objectWithoutProperties(_ref73, _excluded73);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M28,10H23V6a2.0023,2.0023,0,0,0-2-2H11A2.0023,2.0023,0,0,0,9,6v4H4a2.0023,2.0023,0,0,0-2,2V28a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V12A2.0023,2.0023,0,0,0,28,10ZM4,28V12H9v2H7v2H9v2H7v2H9v2H7v2H9v4Zm17,0H11V6H21Zm7,0H23V24h2V22H23V20h2V18H23V16h2V14H23V12h5Z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M14 8H18V10H14zM14 12H18V14H14zM14 16H18V18H14z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var DataCheck = /*#__PURE__*/React.forwardRef(function DataCheck(_ref74, ref) {
  var children = _ref74.children,
    _ref74$size = _ref74.size,
    size = _ref74$size === void 0 ? 16 : _ref74$size,
    rest = _objectWithoutProperties(_ref74, _excluded74);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M23 27.18L20.41 24.59 19 26 23 30 30 23 28.59 21.59 23 27.18z"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "8",
    r: "1"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "16",
    r: "1"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "24",
    r: "1"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M24,3H8A2,2,0,0,0,6,5V27a2,2,0,0,0,2,2h8V27H8V21H26V5A2,2,0,0,0,24,3Zm0,16H8V13H24Zm0-8H8V5H24Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var DataConnected = /*#__PURE__*/React.forwardRef(function DataConnected(_ref75, ref) {
  var children = _ref75.children,
    _ref75$size = _ref75.size,
    size = _ref75$size === void 0 ? 16 : _ref75$size,
    rest = _objectWithoutProperties(_ref75, _excluded75);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M30 30L24 30 24 28 28 28 28 4 24 4 24 2 30 2 30 30z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M24.91,19.59a4.51,4.51,0,0,0-2.66-3.24,4.55,4.55,0,0,0-3.5,0,4.94,4.94,0,0,0-.64.35L15.3,13.89a4.53,4.53,0,1,0-1.41,1.41l2.81,2.81a4.48,4.48,0,0,0-.61,3.3,4.51,4.51,0,0,0,2.66,3.24,4.55,4.55,0,0,0,3.5,0,4.51,4.51,0,0,0,2.66-3.24,4.65,4.65,0,0,0,0-1.82ZM11.5,14A2.5,2.5,0,1,1,14,11.5,2.5,2.5,0,0,1,11.5,14Z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M8 30L2 30 2 2 8 2 8 4 4 4 4 28 8 28 8 30z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var DataError = /*#__PURE__*/React.forwardRef(function DataError(_ref76, ref) {
  var children = _ref76.children,
    _ref76$size = _ref76.size,
    size = _ref76$size === void 0 ? 16 : _ref76$size,
    rest = _objectWithoutProperties(_ref76, _excluded76);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "8",
    r: "1"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "16",
    r: "1"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "24",
    r: "1"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M24,3H8A2,2,0,0,0,6,5V27a2,2,0,0,0,2,2H18V27H8V21H26V5A2,2,0,0,0,24,3Zm0,16H8V13H24Zm0-8H8V5H24Z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M29 24.415L27.586 23 25 25.587 22.414 23 21 24.415 23.586 27 21 29.586 22.414 31 25 28.414 27.586 31 29 29.586 26.414 27 29 24.415z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var DataFormat = /*#__PURE__*/React.forwardRef(function DataFormat(_ref77, ref) {
  var children = _ref77.children,
    _ref77$size = _ref77.size,
    size = _ref77$size === void 0 ? 16 : _ref77$size,
    rest = _objectWithoutProperties(_ref77, _excluded77);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M18 11H26V13H18zM6 19H14V21H6zM10 16a4 4 0 114-4A4.0045 4.0045 0 0110 16zm0-6a2 2 0 102 2A2.002 2.002 0 0010 10zM22 24a4 4 0 114-4A4.0045 4.0045 0 0122 24zm0-6a2 2 0 102 2A2.002 2.002 0 0022 18z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM4,4V28H28V4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var DataReference = /*#__PURE__*/React.forwardRef(function DataReference(_ref78, ref) {
  var children = _ref78.children,
    _ref78$size = _ref78.size,
    size = _ref78$size === void 0 ? 16 : _ref78$size,
    rest = _objectWithoutProperties(_ref78, _excluded78);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M25 12L25 3 23 3 23 5 20 5 20 7 23 7 23 12 20 12 20 14 28 14 28 12 25 12zM8.5 5c1.9299 0 3.5 1.5701 3.5 3.5s-1.5701 3.5-3.5 3.5-3.5-1.5701-3.5-3.5 1.5701-3.5 3.5-3.5m0-2c-3.0376 0-5.5 2.4624-5.5 5.5s2.4624 5.5 5.5 5.5 5.5-2.4624 5.5-5.5-2.4624-5.5-5.5-5.5h0zM23.5 20c1.9299 0 3.5 1.5701 3.5 3.5s-1.5701 3.5-3.5 3.5-3.5-1.5701-3.5-3.5 1.5701-3.5 3.5-3.5m0-2c-3.0376 0-5.5 2.4624-5.5 5.5s2.4624 5.5 5.5 5.5 5.5-2.4624 5.5-5.5-2.4624-5.5-5.5-5.5h0zM6 19L6 21 9.5859 21 4 26.5859 5.4141 28 11 22.4141 11 26 13 26 13 19 6 19z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var DataRegular = /*#__PURE__*/React.forwardRef(function DataRegular(_ref79, ref) {
  var children = _ref79.children,
    _ref79$size = _ref79.size,
    size = _ref79$size === void 0 ? 16 : _ref79$size,
    rest = _objectWithoutProperties(_ref79, _excluded79);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "m27,24c-.4622,0-.8948.1133-1.2859.2998l-4.8289-4.8291c.699-.981,1.1147-2.1768,1.1147-3.4707,0-3.3086-2.6917-6-6-6-1.2937,0-2.4897.416-3.4709,1.1147l-4.8289-4.8286c.1865-.3911.2998-.8237.2998-1.2861,0-1.6567-1.3433-3-3-3s-3,1.3433-3,3,1.3433,3,3,3c.4622,0,.8948-.1133,1.2859-.2998l4.8289,4.8291c-.699.981-1.1147,2.1768-1.1147,3.4707,0,3.3086,2.6917,6,6,6,1.2937,0,2.4897-.416,3.4709-1.1147l4.8289,4.8286c-.1865.3911-.2998.8237-.2998,1.2861,0,1.6567,1.3433,3,3,3s3-1.3433,3-3-1.3433-3-3-3Zm-11-4c-2.2056,0-4-1.7944-4-4s1.7944-4,4-4,4,1.7944,4,4-1.7944,4-4,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var DataSet = /*#__PURE__*/React.forwardRef(function DataSet(_ref80, ref) {
  var children = _ref80.children,
    _ref80$size = _ref80.size,
    size = _ref80$size === void 0 ? 16 : _ref80$size,
    rest = _objectWithoutProperties(_ref80, _excluded80);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M25 12L25 3 23 3 23 5 20 5 20 7 23 7 23 12 20 12 20 14 28 14 28 12 25 12zM8.5 5c1.9299 0 3.5 1.5701 3.5 3.5s-1.5701 3.5-3.5 3.5-3.5-1.5701-3.5-3.5 1.5701-3.5 3.5-3.5m0-2c-3.0376 0-5.5 2.4624-5.5 5.5s2.4624 5.5 5.5 5.5 5.5-2.4624 5.5-5.5-2.4624-5.5-5.5-5.5h0zM8.5 20c1.9299 0 3.5 1.5701 3.5 3.5s-1.5701 3.5-3.5 3.5-3.5-1.5701-3.5-3.5 1.5701-3.5 3.5-3.5m0-2c-3.0376 0-5.5 2.4624-5.5 5.5s2.4624 5.5 5.5 5.5 5.5-2.4624 5.5-5.5-2.4624-5.5-5.5-5.5h0zM23.5 20c1.9299 0 3.5 1.5701 3.5 3.5s-1.5701 3.5-3.5 3.5-3.5-1.5701-3.5-3.5 1.5701-3.5 3.5-3.5m0-2c-3.0376 0-5.5 2.4624-5.5 5.5s2.4624 5.5 5.5 5.5 5.5-2.4624 5.5-5.5-2.4624-5.5-5.5-5.5h0z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var DataStructured = /*#__PURE__*/React.forwardRef(function DataStructured(_ref81, ref) {
  var children = _ref81.children,
    _ref81$size = _ref81.size,
    size = _ref81$size === void 0 ? 16 : _ref81$size,
    rest = _objectWithoutProperties(_ref81, _excluded81);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "7",
    r: "1"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M27,22.14V18a2,2,0,0,0-2-2H17V12h9a2,2,0,0,0,2-2V4a2,2,0,0,0-2-2H6A2,2,0,0,0,4,4v6a2,2,0,0,0,2,2h9v4H7a2,2,0,0,0-2,2v4.14a4,4,0,1,0,2,0V18h8v4H12v8h8V22H17V18h8v4.14a4,4,0,1,0,2,0ZM8,26a2,2,0,1,1-2-2A2,2,0,0,1,8,26Zm10-2v4H14V24ZM6,10V4H26v6ZM26,28a2,2,0,1,1,2-2A2,2,0,0,1,26,28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var DataUnreal = /*#__PURE__*/React.forwardRef(function DataUnreal(_ref82, ref) {
  var children = _ref82.children,
    _ref82$size = _ref82.size,
    size = _ref82$size === void 0 ? 16 : _ref82$size,
    rest = _objectWithoutProperties(_ref82, _excluded82);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4961 18.1318l-7-4c-.1536-.0879-.3248-.1318-.4961-.1318s-.3425.0439-.4961.1318l-7 4c-.3115.1777-.5039.5093-.5039.8682v8c0 .3589.1924.6904.5039.8682l7 4c.1536.0879.325.1318.4961.1318s.3425-.0439.4961-.1318l7-4c.3115-.1777.5039-.5093.5039-.8682v-8c0-.3589-.1924-.6904-.5039-.8682zm-7.4961-1.98l4.9844 2.8481-4.9844 2.8481-4.9844-2.8481 4.9844-2.8481zm-6 4.5713l5 2.8569v5.6968l-5-2.8569v-5.6968zm7 8.5537v-5.6968l5-2.8569v5.6968l-5 2.8569zM28 19v5c0 1.1025-.8972 2-2 2h-3.1719l1.5859-1.5859-1.4141-1.4141-4 4 4 4 1.4141-1.4141-1.5859-1.5859h3.1719c2.2056 0 4-1.7944 4-4v-5h-2zM17.5039 15.0111l-2-1.1428c-.3115-.1781-.5039-.5094-.5039-.8683v-2h2v1.4197l1.4961.8549-.9922 1.7366zM25.5039 14.4175l-1.5039.8594v-2.2769h-2v2.2769l-1.5039-.8594-.9922 1.7368 3 1.7139c.1536.0879.325.1318.4961.1318s.3425-.0439.4961-.1318l3-1.7139-.9922-1.7368zM28.4961 15.0111l-.9922-1.7366 1.4961-.8549v-1.4197h2v2c0 .3589-.1924.6902-.5039.8683l-2 1.1428zM25.4961 8.7256L24.5039 6.9888 23 7.8481 21.4961 6.9888 20.5039 8.7256 22 9.5801 22 11 24 11 24 9.5801 25.4961 8.7256zM30.4961 4.1318l-3-1.7144-.9922 1.7368 1.4805.8457-1.4805.8457.9922 1.7368 1.5039-.8594v2.2769h2v-4c0-.3589-.1924-.6904-.5039-.8682zM24.5039 3.0111l-1.5039-.8594-1.5039.8594-.9922-1.7366 2-1.1428C22.6575.0439 22.8287 0 23 0s.3425.0439.4961.1317l2 1.1428-.9922 1.7366zM19.4961 4.1543l-.9922-1.7368-3 1.7144c-.3115.1777-.5039.5093-.5039.8682v4h2v-2.2769l1.5039.8594.9922-1.7368-1.4805-.8457 1.4805-.8457zM9 1l-1.4141 1.4141 1.5859 1.5859h-3.1719c-2.2056 0-4 1.7944-4 4v5h2v-5c0-1.1025.8972-2 2-2h3.1719l-1.5859 1.5859 1.4141 1.4141 4-4L9 1z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var DataUnstructured = /*#__PURE__*/React.forwardRef(function DataUnstructured(_ref83, ref) {
  var children = _ref83.children,
    _ref83$size = _ref83.size,
    size = _ref83$size === void 0 ? 16 : _ref83$size,
    rest = _objectWithoutProperties(_ref83, _excluded83);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M6 24a2 2 0 11-2 2 2 2 0 012-2m0-2a4 4 0 104 4A4 4 0 006 22zM16 4a2 2 0 11-2 2 2 2 0 012-2m0-2a4 4 0 104 4A4 4 0 0016 2zM26 4a2 2 0 11-2 2 2 2 0 012-2m0-2a4 4 0 104 4A4 4 0 0026 2zM18 24v4H14V24h4m2-2H12v8h8z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M27,22.14V17a2,2,0,0,0-2-2H7V10h3V2H2v8H5v5a2,2,0,0,0,2,2H25v5.14a4,4,0,1,0,2,0ZM4,4H8V8H4ZM26,28a2,2,0,1,1,2-2A2,2,0,0,1,26,28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var DataView = /*#__PURE__*/React.forwardRef(function DataView(_ref84, ref) {
  var children = _ref84.children,
    _ref84$size = _ref84.size,
    size = _ref84$size === void 0 ? 16 : _ref84$size,
    rest = _objectWithoutProperties(_ref84, _excluded84);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "24",
    r: "2"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7769,23.4785A8.64,8.64,0,0,0,22,18a8.64,8.64,0,0,0-7.7769,5.4785L14,24l.2231.5215A8.64,8.64,0,0,0,22,30a8.64,8.64,0,0,0,7.7769-5.4785L30,24ZM22,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,22,28Z"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: "8",
    cy: "8",
    r: "1"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: "8",
    cy: "16",
    r: "1"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: "8",
    cy: "24",
    r: "1"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M5,21h7V19H5V13H21v3h2V5a2,2,0,0,0-2-2H5A2,2,0,0,0,3,5V27a2,2,0,0,0,2,2h7V27H5ZM5,5H21v6H5Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var DataViewAlt = /*#__PURE__*/React.forwardRef(function DataViewAlt(_ref85, ref) {
  var children = _ref85.children,
    _ref85$size = _ref85.size,
    size = _ref85$size === void 0 ? 16 : _ref85$size,
    rest = _objectWithoutProperties(_ref85, _excluded85);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "24",
    r: "2"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7769 23.4785A8.64 8.64 0 0022 18a8.64 8.64 0 00-7.7769 5.4785L14 24l.2231.5215A8.64 8.64 0 0022 30a8.64 8.64 0 007.7769-5.4785L30 24zM22 28a4 4 0 114-4A4.0045 4.0045 0 0122 28zM7 17H12V19H7zM7 12H19V14H7zM7 7H19V9H7z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M22,2,4,2A2.0058,2.0058,0,0,0,2,4V28a2.0058,2.0058,0,0,0,2,2h8V28H4V4H22V15h2V4A2.0058,2.0058,0,0,0,22,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var DataAccessor = /*#__PURE__*/React.forwardRef(function DataAccessor(_ref86, ref) {
  var children = _ref86.children,
    _ref86$size = _ref86.size,
    size = _ref86$size === void 0 ? 16 : _ref86$size,
    rest = _objectWithoutProperties(_ref86, _excluded86);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M28,20H26v2h2v6H4V22H6V20H4a2.0024,2.0024,0,0,0-2,2v6a2.0024,2.0024,0,0,0,2,2H28a2.0024,2.0024,0,0,0,2-2V22A2.0024,2.0024,0,0,0,28,20Z"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "25",
    r: "1"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M21,13a2.9609,2.9609,0,0,0-1.2854.3008L17.4141,11l2.3-2.3008A2.9609,2.9609,0,0,0,21,9a3,3,0,1,0-3-3,2.9665,2.9665,0,0,0,.3,1.2852L16,9.5859,13.7,7.2852A2.9665,2.9665,0,0,0,14,6a3,3,0,1,0-3,3,2.9609,2.9609,0,0,0,1.2854-.3008L14.5859,11l-2.3005,2.3008A2.9609,2.9609,0,0,0,11,13a3,3,0,1,0,3,3,2.9665,2.9665,0,0,0-.3-1.2852L16,12.4141l2.3,2.3007A2.9665,2.9665,0,0,0,18,16a3,3,0,1,0,3-3Zm0-8a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,21,5ZM10,6a1,1,0,1,1,1,1A1.0009,1.0009,0,0,1,10,6Zm1,11a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,11,17Zm10,0a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,21,17Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var DataAnalytics = /*#__PURE__*/React.forwardRef(function DataAnalytics(_ref87, ref) {
  var children = _ref87.children,
    _ref87$size = _ref87.size,
    size = _ref87$size === void 0 ? 16 : _ref87$size,
    rest = _objectWithoutProperties(_ref87, _excluded87);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M12 11H14V17H12zM7 13H9V17H7zM2 7H4V17H2z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "m30,28.5859l-7.5522-7.5522c1.5918-1.9082,2.5522-4.3604,2.5522-7.0337,0-6.0654-4.9346-11-11-11-2.4026,0-4.6853.7607-6.6013,2.2002l1.2012,1.5991c1.5669-1.1772,3.4343-1.7993,5.4001-1.7993,4.9626,0,9,4.0371,9,9s-4.0374,9-9,9c-2.8574,0-5.4819-1.312-7.2007-3.6001l-1.5991,1.2017c2.1001,2.7949,5.3076,4.3984,8.7998,4.3984,2.6733,0,5.1255-.9604,7.0337-2.5522l7.5522,7.5522,1.4141-1.4141Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var DataBackup = /*#__PURE__*/React.forwardRef(function DataBackup(_ref88, ref) {
  var children = _ref88.children,
    _ref88$size = _ref88.size,
    size = _ref88$size === void 0 ? 16 : _ref88$size,
    rest = _objectWithoutProperties(_ref88, _excluded88);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "7",
    r: "1"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "15",
    r: "1"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "23",
    r: "1"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M12,26H4V20h8V18H4V12H22V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V26a2,2,0,0,0,2,2h8ZM4,4H20v6H4Z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M28,17v2.4131A6.996,6.996,0,1,0,22,30V28a5,5,0,1,1,4.5762-7H24v2h6V17Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var DataBin = /*#__PURE__*/React.forwardRef(function DataBin(_ref89, ref) {
  var children = _ref89.children,
    _ref89$size = _ref89.size,
    size = _ref89$size === void 0 ? 16 : _ref89$size,
    rest = _objectWithoutProperties(_ref89, _excluded89);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M28 2H20a2.0023 2.0023 0 00-2 2V28a2.0023 2.0023 0 002 2h8a2.0023 2.0023 0 002-2V4A2.0023 2.0023 0 0028 2zm0 2v7H20V4zm0 9v6H20V13zM20 28V21h8v7zM12 15L10 15 10 13 8 13 8 15 6 15 6 17 8 17 8 19 10 19 10 17 12 17 12 15z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M16,6V4H10A2.0023,2.0023,0,0,0,8,6V9.08A6.99,6.99,0,0,0,8,22.92V26a2.0023,2.0023,0,0,0,2,2h6V26H10V22.92A6.99,6.99,0,0,0,10,9.08V6ZM14,16a5,5,0,1,1-5-5A5.0059,5.0059,0,0,1,14,16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var DataBlob = /*#__PURE__*/React.forwardRef(function DataBlob(_ref90, ref) {
  var children = _ref90.children,
    _ref90$size = _ref90.size,
    size = _ref90$size === void 0 ? 16 : _ref90$size,
    rest = _objectWithoutProperties(_ref90, _excluded90);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM4,4V28H28V4Z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M13 7H15V14H13zM8 7H10V14H8zM22 14H20a2.0021 2.0021 0 01-2-2V9a2.0021 2.0021 0 012-2h2a2.0021 2.0021 0 012 2v3A2.0021 2.0021 0 0122 14zM20 9v3h2V9zM22 18H24V25H22zM8 18H10V25H8zM17 25H15a2.0021 2.0021 0 01-2-2V20a2.0021 2.0021 0 012-2h2a2.0021 2.0021 0 012 2v3A2.0021 2.0021 0 0117 25zm-2-5v3h2V20z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var DataClass = /*#__PURE__*/React.forwardRef(function DataClass(_ref91, ref) {
  var children = _ref91.children,
    _ref91$size = _ref91.size,
    size = _ref91$size === void 0 ? 16 : _ref91$size,
    rest = _objectWithoutProperties(_ref91, _excluded91);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M26,16a3.9612,3.9612,0,0,0-2.02.5657l-2.8586-2.8585,2.293-2.293a2,2,0,0,0,0-2.8284l-6-6a2,2,0,0,0-2.8284,0l-6,6a2,2,0,0,0,0,2.8284l2.293,2.293L8.02,16.5657A4.043,4.043,0,1,0,9.4343,17.98l2.8585-2.8586,2.293,2.293A1.9773,1.9773,0,0,0,15,17.7233V22H12v8h8V22H17V17.7233a1.9773,1.9773,0,0,0,.4142-.3091l2.293-2.293L22.5657,17.98A3.9885,3.9885,0,1,0,26,16ZM8,20a2,2,0,1,1-2-2A2.0023,2.0023,0,0,1,8,20Zm10,4v4H14V24h4Zm-2-8-6-6,6-6,6,6Zm10,6a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,26,22Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var DataCollection = /*#__PURE__*/React.forwardRef(function DataCollection(_ref92, ref) {
  var children = _ref92.children,
    _ref92$size = _ref92.size,
    size = _ref92$size === void 0 ? 16 : _ref92$size,
    rest = _objectWithoutProperties(_ref92, _excluded92);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M30 17L30 15 23.83 15 26.41 12.41 25 11 20 16 25 21 26.41 19.59 23.83 17 30 17zM15 23.83L15 30 17 30 17 23.83 19.59 26.41 21 25 16 20 11 25 12.41 26.41 15 23.83zM7 11L5.59 12.41 8.17 15 2 15 2 17 8.17 17 5.59 19.59 7 21 12 16 7 11zM17 8.17L17 2 15 2 15 8.17 12.41 5.59 11 7 16 12 21 7 19.59 5.59 17 8.17z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var DataDefinition = /*#__PURE__*/React.forwardRef(function DataDefinition(_ref93, ref) {
  var children = _ref93.children,
    _ref93$size = _ref93.size,
    size = _ref93$size === void 0 ? 16 : _ref93$size,
    rest = _objectWithoutProperties(_ref93, _excluded93);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: "14",
    cy: "14",
    r: "2"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M20,30a.9967.9967,0,0,1-.707-.293L8.5859,19A2.0126,2.0126,0,0,1,8,17.5859V10a2.002,2.002,0,0,1,2-2h7.5859A1.9864,1.9864,0,0,1,19,8.5859L29.707,19.293a.9994.9994,0,0,1,0,1.414l-9,9A.9967.9967,0,0,1,20,30ZM10,10v7.5859l10,10L27.5859,20l-10-10Z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M12,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2v8H28V4H4V28h8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var DataDiode = /*#__PURE__*/React.forwardRef(function DataDiode(_ref94, ref) {
  var children = _ref94.children,
    _ref94$size = _ref94.size,
    size = _ref94$size === void 0 ? 16 : _ref94$size,
    rest = _objectWithoutProperties(_ref94, _excluded94);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M30,15H27V7H25v8H22V7H20v7.8262L7.5239,7.1484A1,1,0,0,0,6,8v7H2v2H6v7a1,1,0,0,0,1.5239.8516L20,17.1738V25h2V17h3v8h2V17h3ZM8,22.21V9.79L18.0918,16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var DataEnrichment = /*#__PURE__*/React.forwardRef(function DataEnrichment(_ref95, ref) {
  var children = _ref95.children,
    _ref95$size = _ref95.size,
    size = _ref95$size === void 0 ? 16 : _ref95$size,
    rest = _objectWithoutProperties(_ref95, _excluded95);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28 13h2v2h-2zM23.778 4.797l1.414-1.414 1.414 1.414-1.414 1.414zM15 0h2v2h-2zM6.808 6.233 5.393 4.818l1.415-1.414 1.414 1.414zM2 13h2v2H2zM13 30h6v2h-6zM11 26h10v2H11zM16 4C10.5 4 6 8.5 6 14c0 4.4 2 6.3 3.5 7.6 1 .9 1.5 1.5 1.5 2.4h2c0-1.8-1.1-2.9-2.2-3.9C9.4 18.9 8 17.5 8 14c0-4.4 3.6-8 8-8s8 3.6 8 8c0 3.5-1.4 4.9-2.8 6.1-1.1 1-2.2 2-2.2 3.9h2c0-.9.5-1.5 1.5-2.4C24 20.3 26 18.4 26 14c0-5.5-4.5-10-10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h32v32H0z"
  })))), children);
});
if (process.env.NODE_ENV !== "production") {}
var DataEnrichmentAdd = /*#__PURE__*/React.forwardRef(function DataEnrichmentAdd(_ref96, ref) {
  var children = _ref96.children,
    _ref96$size = _ref96.size,
    size = _ref96$size === void 0 ? 16 : _ref96$size,
    rest = _objectWithoutProperties(_ref96, _excluded96);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _switch2 || (_switch2 = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28 13h2v2h-2zM23.778 4.797l1.414-1.414 1.414 1.414-1.414 1.414zM15 0h2v2h-2zM6.808 6.233 5.393 4.818l1.415-1.414 1.414 1.414zM2 13h2v2H2zM20 13h-3v-3h-2v3h-3v2h3v3h2v-3h3zM13 30h6v2h-6zM11 26h10v2H11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 4C10.5 4 6 8.5 6 14c0 4.4 2 6.3 3.5 7.6 1 .9 1.5 1.5 1.5 2.4h2c0-1.8-1.1-2.9-2.2-3.9C9.4 18.9 8 17.5 8 14c0-4.4 3.6-8 8-8s8 3.6 8 8c0 3.5-1.4 4.9-2.8 6.1-1.1 1-2.2 2-2.2 3.9h2c0-.9.5-1.5 1.5-2.4C24 20.3 26 18.4 26 14c0-5.5-4.5-10-10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h32v32H0z"
  })))), children);
});
if (process.env.NODE_ENV !== "production") {}
var DataPlayer = /*#__PURE__*/React.forwardRef(function DataPlayer(_ref97, ref) {
  var children = _ref97.children,
    _ref97$size = _ref97.size,
    size = _ref97$size === void 0 ? 16 : _ref97$size,
    rest = _objectWithoutProperties(_ref97, _excluded97);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M28 24v2H15.8164a2.983 2.983 0 00-5.6328 0H4V24H2v6H4V28h6.1836a2.983 2.983 0 005.6328 0H28v2h2V24zM13 7.5L13 16.499 13 16.499 21 12 13 7.5z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M16,22A10,10,0,1,1,26,12,10.0113,10.0113,0,0,1,16,22ZM16,4a8,8,0,1,0,8,8A8.0092,8.0092,0,0,0,16,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var DataQualityDefinition = /*#__PURE__*/React.forwardRef(function DataQualityDefinition(_ref98, ref) {
  var children = _ref98.children,
    _ref98$size = _ref98.size,
    size = _ref98$size === void 0 ? 16 : _ref98$size,
    rest = _objectWithoutProperties(_ref98, _excluded98);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _switch3 || (_switch3 = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24.6 24.4L27.2 27 27.2 27 24.6 29.6 26 31 30 27 26 23zM22.4 24.4L19.8 27 19.8 27 22.4 29.6 21 31 17 27 21 23z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "8",
    r: "1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "16",
    r: "1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "24",
    r: "1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,3H8C6.9,3,6,3.9,6,5v22c0,1.1,0.9,2,2,2h7v-2H8v-6h18V5C26,3.9,25.1,3,24,3z M24,19H8v-6h16V19z M24,11H8V5h16V11z"
  })))), children);
});
if (process.env.NODE_ENV !== "production") {}
var DataRefinery = /*#__PURE__*/React.forwardRef(function DataRefinery(_ref99, ref) {
  var children = _ref99.children,
    _ref99$size = _ref99.size,
    size = _ref99$size === void 0 ? 16 : _ref99$size,
    rest = _objectWithoutProperties(_ref99, _excluded99);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M7,30a5,5,0,1,1,5-5A5.0059,5.0059,0,0,1,7,30Zm0-8a3,3,0,1,0,3,3A3.0033,3.0033,0,0,0,7,22Z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M24,26H14V24H24V17H8a2.0021,2.0021,0,0,1-2-2V8A2.0021,2.0021,0,0,1,8,6H18V8H8v7H24a2.0021,2.0021,0,0,1,2,2v7A2.0021,2.0021,0,0,1,24,26Z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M28,12H22a2.0023,2.0023,0,0,1-2-2V4a2.0023,2.0023,0,0,1,2-2h6a2.0023,2.0023,0,0,1,2,2v6A2.0023,2.0023,0,0,1,28,12ZM22,4v6h6V4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var DataRefineryReference = /*#__PURE__*/React.forwardRef(function DataRefineryReference(_ref100, ref) {
  var children = _ref100.children,
    _ref100$size = _ref100.size,
    size = _ref100$size === void 0 ? 16 : _ref100$size,
    rest = _objectWithoutProperties(_ref100, _excluded100);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM28 12H22a2.0023 2.0023 0 01-2-2V4a2.0023 2.0023 0 012-2h6a2.0023 2.0023 0 012 2v6A2.0023 2.0023 0 0128 12zM22 4v6h6V4z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M24,26H16V24h8V17H8a2.0021,2.0021,0,0,1-2-2V8A2.0021,2.0021,0,0,1,8,6H18V8H8v7H24a2.0021,2.0021,0,0,1,2,2v7A2.0021,2.0021,0,0,1,24,26Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var DataShare = /*#__PURE__*/React.forwardRef(function DataShare(_ref101, ref) {
  var children = _ref101.children,
    _ref101$size = _ref101.size,
    size = _ref101$size === void 0 ? 16 : _ref101$size,
    rest = _objectWithoutProperties(_ref101, _excluded101);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M5 25V15.8281l-3.5859 3.586L0 18l6-6 6 6-1.4141 1.4141L7 15.8281V25H19v2H7A2.0024 2.0024 0 015 25zM24 22h4a2.002 2.002 0 012 2v4a2.002 2.002 0 01-2 2H24a2.002 2.002 0 01-2-2V24A2.002 2.002 0 0124 22zm4 6V24H23.9985L24 28zM27 6v9.1719l3.5859-3.586L32 13l-6 6-6-6 1.4141-1.4141L25 15.1719V6H13V4H25A2.0024 2.0024 0 0127 6zM2 6H8V8H2zM2 2H10V4H2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var DataTable = /*#__PURE__*/React.forwardRef(function DataTable(_ref102, ref) {
  var children = _ref102.children,
    _ref102$size = _ref102.size,
    size = _ref102$size === void 0 ? 16 : _ref102$size,
    rest = _objectWithoutProperties(_ref102, _excluded102);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M8 18H12V20H8zM14 18H18V20H14zM8 14H12V16H8zM14 22H18V24H14zM20 14H24V16H20zM20 22H24V24H20z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M27,3H5A2.0025,2.0025,0,0,0,3,5V27a2.0025,2.0025,0,0,0,2,2H27a2.0025,2.0025,0,0,0,2-2V5A2.0025,2.0025,0,0,0,27,3Zm0,2,0,4H5V5ZM5,27V11H27l0,16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var DataTableReference = /*#__PURE__*/React.forwardRef(function DataTableReference(_ref103, ref) {
  var children = _ref103.children,
    _ref103$size = _ref103.size,
    size = _ref103$size === void 0 ? 16 : _ref103$size,
    rest = _objectWithoutProperties(_ref103, _excluded103);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM20 22H24V24H20zM16 18H20V20H16zM20 14H24V16H20zM8 14H12V16H8z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M27,3H5A2.0027,2.0027,0,0,0,3,5V16H5V11H27V27H16v2H27a2.0027,2.0027,0,0,0,2-2V5A2.0027,2.0027,0,0,0,27,3Zm0,6H5V5H27Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var DataVis_1 = /*#__PURE__*/React.forwardRef(function DataVis_1(_ref104, ref) {
  var children = _ref104.children,
    _ref104$size = _ref104.size,
    size = _ref104$size === void 0 ? 16 : _ref104$size,
    rest = _objectWithoutProperties(_ref104, _excluded104);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M26,22a3.9553,3.9553,0,0,0-2.0193.5667L20.167,18.7529a4.9654,4.9654,0,0,0,0-5.5058L22.714,10.7A3.0284,3.0284,0,1,0,21.3,9.286l-2.547,2.547a4.9654,4.9654,0,0,0-5.5058,0L9.4332,8.0191A3.9553,3.9553,0,0,0,10,6a4,4,0,1,0-4,4,3.9553,3.9553,0,0,0,2.0191-.5668l3.8139,3.8139a4.9654,4.9654,0,0,0,0,5.5058L8.0192,22.5668A3.9556,3.9556,0,0,0,6,22a4,4,0,1,0,4,4,3.9553,3.9553,0,0,0-.5667-2.0192l3.8138-3.8138A4.9686,4.9686,0,0,0,15,20.8989v3.2848a3,3,0,1,0,2,0V20.8989a4.9686,4.9686,0,0,0,1.7529-.7319l3.8138,3.8137A3.9553,3.9553,0,0,0,22,26a4,4,0,1,0,4-4ZM16,13a3,3,0,1,1-3,3A3.0033,3.0033,0,0,1,16,13ZM4,6A2,2,0,1,1,6,8,2.002,2.002,0,0,1,4,6ZM6,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,28Zm20,0a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,26,28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var DataVis_2 = /*#__PURE__*/React.forwardRef(function DataVis_2(_ref105, ref) {
  var children = _ref105.children,
    _ref105$size = _ref105.size,
    size = _ref105$size === void 0 ? 16 : _ref105$size,
    rest = _objectWithoutProperties(_ref105, _excluded105);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H17a2.002,2.002,0,0,0-2,2v6H4a2.002,2.002,0,0,0-2,2V28a2.0023,2.0023,0,0,0,2,2H15a2.0023,2.0023,0,0,0,2-2V22H28a2.0027,2.0027,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2Zm0,2,0,4H17V4ZM15.0009,22H4V18H15ZM17,10H28.0007l.0005,4H17Zm-2,2v4H4V12ZM4,28V24H15.0011l0,4Zm13-8V16H28.0015l0,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var DataVis_3 = /*#__PURE__*/React.forwardRef(function DataVis_3(_ref106, ref) {
  var children = _ref106.children,
    _ref106$size = _ref106.size,
    size = _ref106$size === void 0 ? 16 : _ref106$size,
    rest = _objectWithoutProperties(_ref106, _excluded106);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M28,3a2.9913,2.9913,0,0,0-2.8163,2H21.858a3.9807,3.9807,0,0,0-7.716,0H9.858A3.9916,3.9916,0,1,0,5,9.858v4.284a3.9807,3.9807,0,0,0,0,7.716v3.3257a3,3,0,1,0,2,0V21.858a3.978,3.978,0,0,0,1.6729-.9034l3.3638,1.6819A2.9635,2.9635,0,0,0,12,23a3.0117,3.0117,0,1,0,.9221-2.1572L9.7744,19.269A3.95,3.95,0,0,0,10,18a3.9963,3.9963,0,0,0-3-3.858V9.858A3.9947,3.9947,0,0,0,9.858,7h4.284a3.9366,3.9366,0,0,0,4.7816,2.8818l1.8118,3.1705a3.0451,3.0451,0,1,0,1.7326-.9987L20.6893,8.941A3.9839,3.9839,0,0,0,21.858,7h3.3257A2.995,2.995,0,1,0,28,3ZM8,18a2,2,0,1,1-2-2A2.0023,2.0023,0,0,1,8,18ZM6,8A2,2,0,1,1,8,6,2.002,2.002,0,0,1,6,8ZM16,6a2,2,0,1,1,2,2A2.002,2.002,0,0,1,16,6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var DataVis_4 = /*#__PURE__*/React.forwardRef(function DataVis_4(_ref107, ref) {
  var children = _ref107.children,
    _ref107$size = _ref107.size,
    size = _ref107$size === void 0 ? 16 : _ref107$size,
    rest = _objectWithoutProperties(_ref107, _excluded107);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M27,3H5A2.002,2.002,0,0,0,3,5V27a2.0023,2.0023,0,0,0,2,2H27a2.0027,2.0027,0,0,0,2-2V5A2.0023,2.0023,0,0,0,27,3Zm0,6H17V5H27ZM15,27H11V23h4Zm0-6H11V17h4ZM9,21H5V17H9Zm2-6V11H21v4Zm0-6V5h4V9Zm12,2h4l0,4H23ZM9,5V15H5V5ZM5,23H9v4H5Zm12,4V17H27.001l.001,10Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var DataVolume = /*#__PURE__*/React.forwardRef(function DataVolume(_ref108, ref) {
  var children = _ref108.children,
    _ref108$size = _ref108.size,
    size = _ref108$size === void 0 ? 16 : _ref108$size,
    rest = _objectWithoutProperties(_ref108, _excluded108);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M30 20h-4v2h4v2h-3c-1.1046 0-2 .8954-2 2v2c0 1.1046.8954 2 2 2h5v-8c0-1.103-.8975-2-2-2zm0 8h-3v-2h3v2zM24 22v-2h-3v-2h-2v2h-2v2h2v6c0 1.1025.8975 2 2 2h3v-2h-3v-6h3zM14 20h-4v2h4v2h-3c-1.1046 0-2 .8954-2 2v2c0 1.1046.8954 2 2 2h5v-8c0-1.103-.8975-2-2-2zm0 8h-3v-2h3v2zM5 16.0005v4H2c-1.1025 0-2 .897-2 2v5.9995c0 1.1025.8975 2 2 2H7v-13.9995h-2zm-3 5.9995h3v6H2v-6zM4 14V5h7.5857l4 4h12.4143v8h2V9c-.0013-1.1041-.8959-1.9987-2-2h-11.5857l-3.4143-3.4141c-.3742-.3764-.8835-.5873-1.4143-.5859H4c-1.1041.0013-1.9987.8959-2 2V14h2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var DataVolumeAlt = /*#__PURE__*/React.forwardRef(function DataVolumeAlt(_ref109, ref) {
  var children = _ref109.children,
    _ref109$size = _ref109.size,
    size = _ref109$size === void 0 ? 16 : _ref109$size,
    rest = _objectWithoutProperties(_ref109, _excluded109);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M25,29c-1.6543,0-3-1.3458-3-3s1.3457-3,3-3,3,1.3458,3,3-1.3457,3-3,3Zm0-4c-.5515,0-1,.4486-1,1s.4485,1,1,1,1-.4486,1-1-.4485-1-1-1Z"
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: "20",
    cy: "21",
    r: "2"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M15,19c-1.6543,0-3-1.3458-3-3s1.3457-3,3-3,3,1.3458,3,3-1.3457,3-3,3Zm0-4c-.5515,0-1,.4486-1,1s.4485,1,1,1,1-.4486,1-1-.4485-1-1-1Z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M13,27H4c-1.104-.0013-1.9987-.896-2-2V5c.0013-1.104,.896-1.9987,2-2h7.5857c.5308-.0015,1.0401,.2095,1.4143,.5859l3.4143,3.4141h11.5857c1.104,.0013,1.9987,.896,2,2v7h-2v-7H15.5857l-4-4H4V25H13v2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var DatabaseDatastax = /*#__PURE__*/React.forwardRef(function DatabaseDatastax(_ref110, ref) {
  var children = _ref110.children,
    _ref110$size = _ref110.size,
    size = _ref110$size === void 0 ? 16 : _ref110$size,
    rest = _objectWithoutProperties(_ref110, _excluded110);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8684 22.0684l1.7937-1.7476A4.2184 4.2184 0 0023.95 21.9534c1.4026 0 2.0005-.5288 2.0005-1.38 0-.69-.4138-1.1267-1.4717-1.2646l-1.1958-.1612c-2.5754-.3217-4.0009-1.4484-4.0009-3.633 0-2.3225 1.8166-3.7942 4.5529-3.7942a5.7221 5.7221 0 014.691 1.8855l-1.7246 1.7246a3.9649 3.9649 0 00-2.8743-1.2876c-1.2649 0-1.8167.5059-1.8167 1.2417 0 .8049.4368 1.1726 1.5638 1.3567l1.2187.1609c2.6213.3679 3.886 1.5408 3.886 3.5412 0 2.3226-1.9546 3.9322-4.9439 3.9322A6.0942 6.0942 0 0118.8684 22.0684zM4.24 7.95h5.8409c4.185 0 6.9213 2.69 6.9213 8.0254S14.2661 24 10.0811 24H4.24zm5.8409 13.36c2.2534 0 3.7021-1.3338 3.7021-4.07V14.71c0-2.7364-1.4487-4.07-3.7021-4.07H7.2756V21.31z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var DatabaseElastic = /*#__PURE__*/React.forwardRef(function DatabaseElastic(_ref111, ref) {
  var children = _ref111.children,
    _ref111$size = _ref111.size,
    size = _ref111$size === void 0 ? 16 : _ref111$size,
    rest = _objectWithoutProperties(_ref111, _excluded111);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8281 22.0684l1.7937-1.7476A4.2185 4.2185 0 0022.91 21.9534c1.4025 0 2-.5288 2-1.38 0-.69-.4138-1.1267-1.4716-1.2646l-1.1958-.1612c-2.5755-.3217-4.001-1.4484-4.001-3.633 0-2.3225 1.8166-3.7942 4.553-3.7942a5.722 5.722 0 014.6909 1.8855l-1.7246 1.7246a3.9643 3.9643 0 00-2.8743-1.2876c-1.2649 0-1.8166.5059-1.8166 1.2417 0 .8049.4367 1.1726 1.5637 1.3567l1.2187.1609c2.6214.3679 3.886 1.5408 3.886 3.5413 0 2.3225-1.9546 3.9321-4.9438 3.9321A6.0944 6.0944 0 0117.8281 22.0684zM5.2471 24V7.95H15.825v2.69H8.2825v3.8862h6.6687v2.6905H8.2825V21.31H15.825V24z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var DatabaseEnterpriseDb2 = /*#__PURE__*/React.forwardRef(function DatabaseEnterpriseDb2(_ref112, ref) {
  var children = _ref112.children,
    _ref112$size = _ref112.size,
    size = _ref112$size === void 0 ? 16 : _ref112$size,
    rest = _objectWithoutProperties(_ref112, _excluded112);
  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation["DatabaseEnterpriseDb2"]) {
      didWarnAboutDeprecation["DatabaseEnterpriseDb2"] = true;
      console.warn("Icon name was requested by the product team to be renamed to and replaced by database--enterprisedb. As a result, the DatabaseEnterpriseDb2 component will be removed in the next major version of @carbon/icons-react.");
    }
  }
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M17.84 24V11.9966H20.783v2h.1149a3.3115 3.3115 0 013.3572-2.2764c2.46 0 3.84 1.7017 3.84 4.6909V24H25.1519V16.7107c0-1.7017-.5748-2.5754-1.9776-2.5754-1.2187 0-2.3913.6438-2.3913 1.9314V24zM4.2236 24V7.95H14.8015v2.69H7.259v3.8862h6.6687v2.6905H7.259V21.31h7.5425V24z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var DatabaseEnterprisedb = /*#__PURE__*/React.forwardRef(function DatabaseEnterprisedb(_ref113, ref) {
  var children = _ref113.children,
    _ref113$size = _ref113.size,
    size = _ref113$size === void 0 ? 16 : _ref113$size,
    rest = _objectWithoutProperties(_ref113, _excluded113);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M17.84 24V11.9966H20.783v2h.1149a3.3115 3.3115 0 013.3572-2.2764c2.46 0 3.84 1.7017 3.84 4.6909V24H25.1519V16.7107c0-1.7017-.5748-2.5754-1.9776-2.5754-1.2187 0-2.3913.6438-2.3913 1.9314V24zM4.2236 24V7.95H14.8015v2.69H7.259v3.8862h6.6687v2.6905H7.259V21.31h7.5425V24z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var DatabaseEtcd = /*#__PURE__*/React.forwardRef(function DatabaseEtcd(_ref114, ref) {
  var children = _ref114.children,
    _ref114$size = _ref114.size,
    size = _ref114$size === void 0 ? 16 : _ref114$size,
    rest = _objectWithoutProperties(_ref114, _excluded114);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9443 20.9417v-6.6h-1.77V11.9966h.92c.8735 0 1.1494-.4138 1.1494-1.2417V8.7083h2.6445v3.2883h2.46V14.342h-2.46v7.3125h2.2764V24H24.0488A2.778 2.778 0 0120.9443 20.9417zM6.6846 24V7.95H17.2627v2.69H9.72v3.8862h6.669v2.6905H9.72V21.31h7.543V24z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var DatabaseMessaging = /*#__PURE__*/React.forwardRef(function DatabaseMessaging(_ref115, ref) {
  var children = _ref115.children,
    _ref115$size = _ref115.size,
    size = _ref115$size === void 0 ? 16 : _ref115$size,
    rest = _objectWithoutProperties(_ref115, _excluded115);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "m23,32l-1.755-1,2.755-4h4v-7h-12v7h4v2h-4c-1.1025,0-2-.8975-2-2v-7c0-1.1025.8975-2,2-2h12c1.1025,0,2,.8975,2,2v7c0,1.1025-.8975,2-2,2h-3l-2,3Z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "m13,2C7.7021,2,2,3.252,2,6v18c0,2.4033,4.3618,3.6626,9,3.9404v-2.0015c-4.5337-.2803-6.8674-1.4644-7-1.939v-3.5723c1.7065.856,4.3062,1.3442,7,1.5063v-1.9951c-4.5337-.2803-6.8674-1.4644-7-1.939v-3.5723c2.1279,1.0674,5.6426,1.5723,9,1.5723,5.2979,0,11-1.252,11-4v-6.0005c-.0007-2.748-5.7024-3.9995-11-3.9995ZM3.9985,6.0151c.1523-.5552,3.1514-2.0151,9.0015-2.0151,5.7976,0,8.7949,1.4341,8.9968,2-.2019.5659-3.1992,2-8.9968,2-5.8501,0-8.8491-1.46-9.0015-1.9849Zm18.0015,5.9722c-.1606.5571-3.1587,2.0127-9,2.0127-5.8501,0-8.8491-1.46-9-2v-3.5723c2.1279,1.0674,5.6426,1.5723,9,1.5723s6.8721-.5049,9-1.5723v3.5596Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var DatabaseMongodb = /*#__PURE__*/React.forwardRef(function DatabaseMongodb(_ref116, ref) {
  var children = _ref116.children,
    _ref116$size = _ref116.size,
    size = _ref116$size === void 0 ? 16 : _ref116$size,
    rest = _objectWithoutProperties(_ref116, _excluded116);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3481 28.875c-4.0473 0-5.5878-1.0579-5.5878-2.8284a2.2115 2.2115 0 012.1386-2.3v-.253a1.9726 1.9726 0 01-1.5405-2c0-1.242 1.0576-1.8628 2.207-2.1158v-.0918a3.6228 3.6228 0 01-2.1845-3.4953c0-2.4375 1.7246-4.07 4.9672-4.07A6.6717 6.6717 0 0127.44 12.02v-.3908a1.5343 1.5343 0 011.7022-1.7476h1.8623v2.2534H28.4521v.322a3.5917 3.5917 0 011.8628 3.3343c0 2.4145-1.7016 4.0241-4.9668 4.0241a7.3662 7.3662 0 01-1.8393-.207 1.23 1.23 0 00-.8511 1.0808c0 .5979.5059.8967 1.564.8967H27.44c2.9434 0 4.208 1.2649 4.208 3.4263C31.6484 27.5183 29.9473 28.875 25.3481 28.875zm1.4947-4.7371H22.75a1.473 1.473 0 00-.6211 1.2417c0 .92.6895 1.4717 2.5293 1.4717H26.13c1.9087 0 2.76-.4829 2.76-1.4946C28.89 24.5979 28.3374 24.1379 26.8428 24.1379zm.667-8.163v-.3912c0-1.2187-.7588-1.84-2.1617-1.84s-2.1616.6209-2.1616 1.84v.3912c0 1.1955.7588 1.84 2.1616 1.84S27.51 17.17 27.51 15.9749zM2.2344 7.95H5.66l4.1162 7.8413h.0923l4.07-7.8413h3.2886V24H14.3525V12.48h-.0918L13.0186 15.032l-3.2881 6.07-3.2881-6.07L5.2007 12.48H5.1084V24H2.2344z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var DatabasePostgreSql = /*#__PURE__*/React.forwardRef(function DatabasePostgreSql(_ref117, ref) {
  var children = _ref117.children,
    _ref117$size = _ref117.size,
    size = _ref117$size === void 0 ? 16 : _ref117$size,
    rest = _objectWithoutProperties(_ref117, _excluded117);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M22.98 28.875c-4.0474 0-5.5879-1.0579-5.5879-2.8284a2.2112 2.2112 0 012.1387-2.3v-.253a1.9725 1.9725 0 01-1.541-2c0-1.242 1.0576-1.8628 2.2075-2.1158v-.0918a3.622 3.622 0 01-2.1846-3.4953c0-2.4375 1.7246-4.07 4.9673-4.07a6.6768 6.6768 0 012.0923.2988v-.3908a1.5341 1.5341 0 011.7016-1.7476h1.8623v2.2534H26.0835v.322a3.5926 3.5926 0 011.8628 3.3343c0 2.4145-1.7022 4.0241-4.9668 4.0241a7.3717 7.3717 0 01-1.84-.207 1.23 1.23 0 00-.8505 1.0808c0 .5979.5058.8967 1.5634.8967h3.2193c2.9433 0 4.208 1.2649 4.208 3.4263C29.28 27.5183 27.5781 28.875 22.98 28.875zm1.4941-4.7371H20.3809A1.474 1.474 0 0019.76 25.38c0 .92.69 1.4717 2.5293 1.4717h1.4716c1.9092 0 2.76-.4829 2.76-1.4946C26.5205 24.5979 25.9688 24.1379 24.4736 24.1379zm.667-8.163v-.3912c0-1.2187-.7588-1.84-2.1611-1.84s-2.1621.6209-2.1621 1.84v.3912c0 1.1955.7588 1.84 2.1621 1.84S25.1406 17.17 25.1406 15.9749zM4.603 24V7.95h7.22c2.9668 0 4.76 2 4.76 4.967 0 2.9893-1.7935 4.9668-4.76 4.9668H7.6387V24zm3.0357-8.738h3.9092a1.6886 1.6886 0 001.8852-1.8167V12.3875a1.672 1.672 0 00-1.8852-1.7935H7.6387z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var DatabaseRabbit = /*#__PURE__*/React.forwardRef(function DatabaseRabbit(_ref118, ref) {
  var children = _ref118.children,
    _ref118$size = _ref118.size,
    size = _ref118$size === void 0 ? 16 : _ref118$size,
    rest = _objectWithoutProperties(_ref118, _excluded118);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9434 20.7346c0-2.46 1.8623-3.6792 5.1279-3.6792h2.0464v-.8738c0-1.3337-.6665-2.1154-2.23-2.1154a3.1249 3.1249 0 00-2.7363 1.5175L18.4033 14.02a5.0544 5.0544 0 014.6909-2.3c3.2422 0 4.9668 1.54 4.9668 4.2771v5.6567h1.1958V24H27.624a2.184 2.184 0 01-2.23-2.07h-.1377c-.3912 1.5408-1.7017 2.3455-3.4952 2.3455C19.3232 24.2759 17.9434 22.8733 17.9434 20.7346zm7.1743-.3218V18.8262H23.2324c-1.541 0-2.3.5288-2.3 1.4717v.3908c0 .9658.667 1.4488 1.8164 1.4488C24.06 22.1375 25.1177 21.54 25.1177 20.4128zM6.9717 24H3.9365V7.95H11.18c2.92 0 4.7373 1.9316 4.7373 4.967a4.4237 4.4237 0 01-2.9893 4.553L16.2158 24h-3.38L9.8462 17.8145H6.9717zm3.9092-8.738a1.689 1.689 0 001.8857-1.8167V12.3875a1.6723 1.6723 0 00-1.8857-1.7935H6.9717v4.668z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var DatabaseRedis = /*#__PURE__*/React.forwardRef(function DatabaseRedis(_ref119, ref) {
  var children = _ref119.children,
    _ref119$size = _ref119.size,
    size = _ref119$size === void 0 ? 16 : _ref119$size,
    rest = _objectWithoutProperties(_ref119, _excluded119);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7156 22h-.115a3.371 3.371 0 01-3.3113 2.2764c-3.0124 0-4.6912-2.2764-4.6912-6.3006 0-4.0012 1.6788-6.2546 4.6912-6.2546a3.3049 3.3049 0 013.3113 2.2534h.115v-6.99h2.9433V24H25.7156zm0-2.1157V16.0667c0-1.1727-1.0808-1.9314-2.4837-1.9314A2.556 2.556 0 0020.68 16.9636v2.07a2.5365 2.5365 0 002.5522 2.8052C24.6348 21.8384 25.7156 21.1257 25.7156 19.8838zM6.5576 24H3.5222V7.95h7.2434c2.92 0 4.7371 1.9316 4.7371 4.967a4.4237 4.4237 0 01-2.9893 4.553L15.8018 24h-3.38L9.4321 17.8145H6.5576zm3.9092-8.738a1.6888 1.6888 0 001.8855-1.8167V12.3875a1.6722 1.6722 0 00-1.8855-1.7935H6.5576v4.668z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Datastore = /*#__PURE__*/React.forwardRef(function Datastore(_ref120, ref) {
  var children = _ref120.children,
    _ref120$size = _ref120.size,
    size = _ref120$size === void 0 ? 16 : _ref120$size,
    rest = _objectWithoutProperties(_ref120, _excluded120);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "23",
    r: "1"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M8 22H20V24H8z"
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "9",
    r: "1"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8H20V10H8z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M26,14a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2H6A2,2,0,0,0,4,6v6a2,2,0,0,0,2,2H8v4H6a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V20a2,2,0,0,0-2-2H24V14ZM6,6H26v6H6ZM26,26H6V20H26Zm-4-8H10V14H22Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Db2BufferPool = /*#__PURE__*/React.forwardRef(function Db2BufferPool(_ref121, ref) {
  var children = _ref121.children,
    _ref121$size = _ref121.size,
    size = _ref121$size === void 0 ? 16 : _ref121$size,
    rest = _objectWithoutProperties(_ref121, _excluded121);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M26.338 31L24.602 30 26.8895 26 23 26 26.993 19 28.73 20 26.4463 24 30.3367 24 26.338 31zM8 14H12V16H8zM20 14H24V16H20zM8 18H12V20H8zM14 18H18V20H14zM14 22H18V24H14z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M5,11H27v5h2V5c0-1.1025-.8972-2-2-2H5c-1.1028,0-2,.8975-2,2V27c0,1.1025,.8972,2,2,2h15v-2H5V11ZM27,5v4H5V5H27Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Db2DataSharingGroup = /*#__PURE__*/React.forwardRef(function Db2DataSharingGroup(_ref122, ref) {
  var children = _ref122.children,
    _ref122$size = _ref122.size,
    size = _ref122$size === void 0 ? 16 : _ref122$size,
    rest = _objectWithoutProperties(_ref122, _excluded122);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M8 28v-6.1699l2.5898 2.5801 1.4102-1.4102-5-5-5 5 1.4102 1.4102 2.5898-2.5801v6.1699c0 1.1025.8972 2 2 2h9v-2H8zM25 17c-2.8506 0-5 1.29-5 3v7c0 1.71 2.1494 3 5 3s5-1.29 5-3v-7c0-1.71-2.1494-3-5-3zm0 2c1.936 0 3 .751 3 1s-1.064 1-3 1-3-.751-3-1 1.064-1 3-1zm0 9c-1.936 0-3-.751-3-1v-4.5796c.8264.3623 1.8508.5796 3 .5796s2.1736-.2173 3-.5796v4.5796c0 .249-1.064 1-3 1zM28.5898 7.5898l-2.5898 2.5801V4c0-1.1025-.8972-2-2-2H15v2h9v6.1699l-2.5898-2.5801-1.4102 1.4102 5 5 5-5-1.4102-1.4102zM7 15c2.8506 0 5-1.29 5-3V5c0-1.71-2.1494-3-5-3S2 3.29 2 5v7c0 1.71 2.1494 3 5 3zm0-11c1.936 0 3 .751 3 1s-1.064 1-3 1-3-.751-3-1 1.064-1 3-1zm-3 3.4204c.8264.3623 1.8508.5796 3 .5796s2.1736-.2173 3-.5796v4.5796c0 .249-1.064 1-3 1s-3-.751-3-1V7.4204z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Db2Database = /*#__PURE__*/React.forwardRef(function Db2Database(_ref123, ref) {
  var children = _ref123.children,
    _ref123$size = _ref123.size,
    size = _ref123$size === void 0 ? 16 : _ref123$size,
    rest = _objectWithoutProperties(_ref123, _excluded123);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M16,3c-5.2979,0-11,1.252-11,4V25c0,2.748,5.7021,4,11,4s11-1.252,11-4V7c0-2.748-5.7021-4-11-4Zm0,2c5.7976,0,8.7949,1.4341,8.9968,2-.2019,.5659-3.1992,2-8.9968,2-5.8413,0-8.8394-1.4556-9-1.9824v-.0049c.1606-.5571,3.1587-2.0127,9-2.0127ZM7,9.4277c2.1279,1.0674,5.6426,1.5723,9,1.5723s6.8721-.5049,9-1.5723v3.5596c-.1606,.5571-3.1587,2.0127-9,2.0127-5.8501,0-8.8491-1.46-9-2v-3.5723Zm0,6c2.1279,1.0674,5.6426,1.5723,9,1.5723s6.8721-.5049,9-1.5723v3.5596c-.1606,.5571-3.1587,2.0127-9,2.0127-5.8501,0-8.8491-1.46-9-2v-3.5723Zm9,11.5723c-5.8501,0-8.8491-1.46-9-2v-3.5723c2.1279,1.0674,5.6426,1.5723,9,1.5723s6.8721-.5049,9-1.5723v3.5596c-.1606,.5571-3.1587,2.0127-9,2.0127Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Debug = /*#__PURE__*/React.forwardRef(function Debug(_ref124, ref) {
  var children = _ref124.children,
    _ref124$size = _ref124.size,
    size = _ref124$size === void 0 ? 16 : _ref124$size,
    rest = _objectWithoutProperties(_ref124, _excluded124);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M29.83,20l.34-2L25,17.15V13c0-.08,0-.15,0-.23l5.06-1.36-.51-1.93-4.83,1.29A9,9,0,0,0,20,5V2H18V4.23a8.81,8.81,0,0,0-4,0V2H12V5a9,9,0,0,0-4.71,5.82L2.46,9.48,2,11.41,7,12.77c0,.08,0,.15,0,.23v4.15L1.84,18l.32,2L7,19.18a8.9,8.9,0,0,0,.82,3.57L3.29,27.29l1.42,1.42,4.19-4.2a9,9,0,0,0,14.2,0l4.19,4.2,1.42-1.42-4.54-4.54A8.9,8.9,0,0,0,25,19.18ZM15,25.92A7,7,0,0,1,9,19V13h6ZM9.29,11a7,7,0,0,1,13.42,0ZM23,19a7,7,0,0,1-6,6.92V13h6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var DecisionNode = /*#__PURE__*/React.forwardRef(function DecisionNode(_ref125, ref) {
  var children = _ref125.children,
    _ref125$size = _ref125.size,
    size = _ref125$size === void 0 ? 16 : _ref125$size,
    rest = _objectWithoutProperties(_ref125, _excluded125);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m28,2v8h-4L16,2l-8,8h-4V2h-2v8c0,1.1025.8972,2,2,2h4l7,7v7.1719l-2.5859-2.5859-1.4141,1.4141,5,5,5-5-1.4141-1.4141-2.5859,2.5859v-7.1719l7-7h4c1.1028,0,2-.8975,2-2V2h-2Zm-12,15.1714l-6.1714-6.1714,6.1714-6.1714,6.1714,6.1714-6.1714,6.1714Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
export { ContainerImagePushPull, ContainerRegistry, ContainerServices, ContainerSoftware, ContentDeliveryNetwork, ContentView, Continue, ContinueFilled, ContinuousDeployment, ContinuousIntegration, Contrast, ConvertToCloud, Cookie, Copy, CopyFile, CopyLink, Corn, Corner, Coronavirus, Cost, CostTotal, Cough, Course, Covariate, CreateLink, Credentials, Critical, CriticalSeverity, Crop, CropGrowth, CropHealth, CrossTab, Crossroads, CrowdReport, CrowdReportFilled, Csv, Cube, CubeView, Currency, CurrencyBaht, CurrencyDollar, CurrencyEuro, CurrencyLira, CurrencyPound, CurrencyRuble, CurrencyRupee, CurrencyShekel, CurrencyWon, CurrencyYen, Cursor_1, Cursor_2, Customer, CustomerService, Cut, CutOut, Cyclist, Dashboard, DashboardReference, DataAccessor, DataAnalytics, DataBackup, DataBase, DataBaseAlt, DataBin, DataBlob, DataCategorical, DataCenter, DataCheck, DataClass, DataCollection, DataConnected, DataDefinition, DataDiode, DataEnrichment, DataEnrichmentAdd, DataError, DataFormat, DataPlayer, DataQualityDefinition, DataReference, DataRefinery, DataRefineryReference, DataRegular, DataSet, DataShare, DataStructured, DataTable, DataTableReference, DataUnreal, DataUnstructured, DataView, DataViewAlt, DataVis_1, DataVis_2, DataVis_3, DataVis_4, DataVolume, DataVolumeAlt, Data_1, Data_2, DatabaseDatastax, DatabaseElastic, DatabaseEnterpriseDb2, DatabaseEnterprisedb, DatabaseEtcd, DatabaseMessaging, DatabaseMongodb, DatabasePostgreSql, DatabaseRabbit, DatabaseRedis, Datastore, Db2BufferPool, Db2DataSharingGroup, Db2Database, Debug, DecisionNode, QCU1, QCU3, QCY, QCZ, WatsonHealthContourDraw, WatsonHealthContourEdit, WatsonHealthContourFinding, WatsonHealthCrossReference, WatsonHealthCutInHalf };